import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ColDef, ExcelExportParams, GridApi, GridOptions, GridReadyEvent, ICellRendererParams, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { DateAdapter } from '@angular/material/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { ThreeSixtyDegreePopupsComponent } from 'src/app/shared/popups/three-sixty-degree-popups/three-sixty-degree-popups.component';
import { ThreeSixtyDashboardPopupsComponent } from 'src/app/shared/popups/three-sixty-dashboard-popups/three-sixty-dashboard-popups.component';
import { ThreeSixtyReviewPopupComponent } from 'src/app/shared/popups/three-sixty-review-popup/three-sixty-review-popup.component';
import { EssDetailsPopupComponent } from 'src/app/shared/popups/ess-details-popup/ess-details-popup.component';

import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { HttpService } from 'src/app/service/http/http.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';

import { ToastrService } from 'ngx-toastr';
import * as echarts from 'echarts';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import { saveAs } from 'file-saver';
import autoTable from 'jspdf-autotable';
import { Config } from 'src/app/app-constant';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { environment } from 'src/environments/environment';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-three-sixty-degree',
  templateUrl: './three-sixty-degree.component.html',
  styleUrls: ['./three-sixty-degree.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class ThreeSixtyDegreeComponent implements OnInit {
  loggedInUserRole: any;
  buttonColorName: any;
  selectedTypeTabName = 'Dashboard';
  selectedTypeTabIndex = 0;
  showSetupPopup: boolean = false;
  dropdownSettings: IDropdownSettings = {};
  subModuleButtonColor: any;
  isShowSaveBtn: any = false;
  onSeletReminderOption: any;

  reviewMasterTableTotalPageCount: any = 25;
  currentPageNumberOfSurveyMasterTable: any = 1;
  totalPagesOfSurveyMasterTable: any = 0;
  isDisabledDatePicker: any = true;

  demo = [{ ratings: '0' }, { ratings: '1' }, { ratings: '2' }, { ratings: '3' }, { ratings: '4' }, { ratings: '5' }];

  selectedSubTab: any = 'A-Z report';

  showInfoPopup: any = false;
  selectedYear: any;
  selectedYearCompetencyWise: any;
  selectedYearQuestionWise: any;
  selectedYearStakeholderWise: any;
  selectedYearHowDidFareWise: any;
  yearsOfCompany: any = [];
  loggedInCompanyFiscalyear: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInUserEmail: any;
  subordinateWeightage: any = null;
  superiorWeightage: any = null;
  selfWeightage: any = null;
  peerWeightage: any = null;
  externalCustomerWeightage: any = null;
  internalCustomerWeightage: any = null;
  stakeholdersArray: any = [];
  getCompetencyList: any = [];
  loggedInUserName: any;
  selectedReviewCompetencyWiseID: any;
  isPublished: boolean = false;

  competencyWiseIcon: any = 'bar';
  competencyWiseTable: any = false;
  questionWiseIcon: any = 'bar';
  questionWiseTable: any = false;
  stakeholderWiseIcon: any = 'bar';
  stakeholderWiseTable: any = false;
  HowDidIFareIcon: any = 'bar';
  HowDidIFareTable: any = false;
  trendAnalysisIcon: any = 'bar';
  trendAnalysisTableIcon: any = false;
  demographicTrendAnalysisIcon: any = 'bar';
  demographicTrendAnalysisTableIcon: any = false;

  demographicComparisonGraphType: any = {
    bar: {},
    pie: {},
    line: {}
  };
  completionStatusGraphType: any = {
    bar: {},
    pie: {},
    line: {}
  };

  bandlistForCompetencyWiseGraph: any = [];
  selectedBandCompetencyWiseGraph: any;
  selectedEmployeeCompetencyWiseGraph: any;
  empListForCompetencyWiseGraph: any = [];
  listofReviewNamesActiveAndCompletedCompetencyWise: any = [];
  selectedReviewQuestionWiseID: any;
  selectedReviewSatkeholderWiseID: any;
  trendAnalysisReportSearch: any;

  competencyWiseGraphData: any = [];
  listofReviewNamesActiveAndCompletedQuestionWise: any = [];
  competencylistForQuestionWiseGraph: any = [];
  listOfEmpForQuestionWise: any = [];
  selectedCompetencyQuestionWise: any;
  questionWiseGraphData: any = [];
  selectedEmployeeQuestionWiseGraph: any;
  listofReviewNamesActiveAndCompletedSatkeholderWise: any = [];
  listOfEmpForStakeholderWise: any = [];
  selectedEmployeeStakeholderWise: any;
  stakeholderWiseGraphData: any = [];
  listofReviewNamesActiveAndCompletedHowDidIFareWise: any = [];
  selectedReviewHowDidFareWiseID: any;
  howDidIFareWiseGraphData: any = [];
  listofReviewNamesActiveAndCompletedTopandBottomWise: any = [];
  listOfEmpForTopandBottomWise: any = [];
  selectedYearTopandBottom: any;
  selectedReviewTopandBottomId: any;
  selectedReviewSpidergraphId: any;
  selectedEmployeeForTopandBottom: any;
  topandBottomGraphData: any = [];
  istopandbottomAnalysis: boolean = true;
  selectedYearSpiderWeb: any;
  listofReviewNamesActiveAndCompletedSpiderGraph: any = [];
  listOfEmpForSpiderGraph: any = [];
  spiderGraphData: any = [];
  selectedEmployeeForSpiderGraph: any;
  loggedInUserIsMD: any;
  listof360ReviewColumnDef: any = [];
  listof360ReviewColumnDefCopyForDailog: any = [];
  ScoreGivenByYouReportColumnDef: any = [];
  trendAnalysisReportColumnDef: any = [];
  trendAnalysisCompetencyColumnDef: any = [];
  isDetailsCompetencyOpen: boolean = false;

  columnDefsForDumpReport: ColDef[] = [];
  rowDataForDumpReport: any[] = [];
  pinnedBottomRowData: any[] = [];
  gridApis: { [id: string]: GridApi } = {};
  constructor(
    private encryptionService: EncryptionService,
    public router: Router,
    private activatedroute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    public sharedService: SharedService,
    private loader: LoaderService,
    private httpService: HttpService,
    private config: Config,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private pdfDownload: DownloadAsPdfService,
    public mobileResponsiveService: MobileResponsiveService
  ) {}

  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserEmail = sessionStorage.getItem('userEmail');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserIsMD = sessionStorage.getItem('loggedInUserIsMD');
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.defaultCall360ReviewColumn();
    this.Scoregivenbyyoureport();
    this.getEmployeeDetiailsBandLocation();
  }

  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  gridColumnApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false // ✅ small filter box under header
  };

  defaultColDefForDumpReport: ColDef = {
    flex: 1,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false // ✅ small filter box under header
  };
  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      minWidth: 80,
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: { type: 'multiple' }, // ✅ object format for v32+
    localeText: { noRowsToShow: 'No Data Found' },
    suppressRowTransform: true, // ✅ required for rowSpan to work
    getRowStyle: (params: any) => {
      if (params.node.rowPinned) {
        return {
          fontWeight: 'bold',
          background: '#f4f4f4',
          color: '#000'
        };
      }
      return null;
    },
    onFilterChanged: () => {
      this.updatePinnedBottomRow();
    }
  };

  //for Score Given by you report
  gridOptionsScoreGiven: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      minWidth: 80,

      // ✅ add this
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: 'multiple', // ✅ multiple selection allowed
    localeText: {
      noRowsToShow: 'No Data Found' // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    },
    getRowStyle: (params: any) => {
      if (params.node.rowPinned) {
        return {
          fontWeight: 'bold',
          background: '#f4f4f4',
          color: '#000'
        };
      }
      return null;
    }
  };
  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    // delete icon listener lagao
    setTimeout(() => {
      const deleteIcon = document.getElementById('deleteIcon');
      if (deleteIcon) {
        deleteIcon.addEventListener('click', () => {
          // ✅ Sirf tab delete chale jab enabled ho
          if (deleteIcon.getAttribute('data-enabled') === 'true') {
            this.softDeleteEssByIds();
          }
        });
      }
    }, 0);
  }
  selectedRowsCount = 0;

  onGridReadyForDumpReport(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    // Total row set karna
    // const totalRow = this.getTotalRow();
    // this.gridApi.setPinnedBottomRowData(totalRow);
    this.updatePinnedBottomRow(); // initial load
  }

  // ✅ Selection change hone par delete icon enable/disable hoga
  onSelectionChanged() {
    const deleteIcon = document.getElementById('deleteIcon');
    if (!deleteIcon) return;

    const selectedRows = this.gridApi.getSelectedRows();
    const allPending = selectedRows.length > 0 && selectedRows.every((row: any) => row.reviewStatus === 'Pending');

    if (allPending) {
      // enable delete
      deleteIcon.setAttribute('data-enabled', 'true');
      deleteIcon.style.color = 'red';
      deleteIcon.style.cursor = 'pointer';
    } else {
      // disable delete
      deleteIcon.setAttribute('data-enabled', 'false');
      deleteIcon.style.color = 'lightgray';
      deleteIcon.style.cursor = 'not-allowed';
    }
  }

  // onSelectionChanged() {
  //   if (!this.gridApi) return;

  //   this.selectedRowsCount = this.gridApi.getSelectedRows().length;

  //   // color update karo selection ke hisaab se
  //   const deleteIcon = document.getElementById('deleteIcon');
  //   if (deleteIcon) {
  //     deleteIcon.style.color = this.selectedRowsCount > 0 ? 'red' : 'gray';
  //   }
  // }

  onFirstDataRendered(params: any) {
    params.api.autoSizeAllColumns();
  }

  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  // Helper function to convert any date string into dd-MM-yyyy
  formatDateOnly(dateStr: string | null): string | null {
    if (!dateStr) return null;

    let datePart = dateStr;
    if (dateStr.includes('T')) {
      datePart = dateStr.split('T')[0];
    }

    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;

    // Date object
    const date = new Date(y, m - 1, d);

    // Format dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');
  }

  onBtExportForTrendAnalysis(strMsg: any) {
    const params: ExcelExportParams = {
      fileName: strMsg + '_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: strMsg,
      exportAsExcelTable: {
        showRowStripes: true,
        name: strMsg
      },
      processCellCallback: cell => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['startDate', 'endDate']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // capitalize each word
        }

        return value;
      }
    };

    this.gridApiTrendAnalysis.exportDataAsExcel(params);
  }

  onBtExport(strMsg: any) {
    const params: ExcelExportParams = {
      fileName: strMsg + '_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: strMsg,
      exportAsExcelTable: {
        showRowStripes: true,
        name: strMsg
      },
      processCellCallback: cell => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['startDate', 'endDate']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // capitalize each word
        }

        return value;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {
    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', e => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  };

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    // this.isDetailsOpen = true;
  }
  //Score given by you report
  onRowClickedForScoreGivenBy(event: any, relation: any) {
    this.selectedRow = {
      ...event.data,
      relation: relation.relation,
      empName: relation.empName
    };
    console.log(this.selectedRow);
    this.isDetailsOpen = true;
  }
  //Trend analysis report
  onRowClickedFortrendAnalysis(event: any) {
    console.log('Clicked Column:**', event.colDef);
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  onRowClickedFortrendAnalysisCompetency(event: any) {
    console.log('Clicked Column:**', event.colDef);
    this.selectedRow = event.data;
    this.isDetailsCompetencyOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;

  searchTaskString: string = '';
  resetGrid() {
    this.isClicked = true; // Trigger animation

    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState(); // ✅ Reset columns
    }
  }
  // For Trend Analysis Competency
  isClickedCompetency = false;
  resetGridCompetency() {
    this.isClickedCompetency = true; // Trigger animation

    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState(); // ✅ Reset columns
    }
  }
  //A-Z Report
  isClickedAZReport = false;
  resetGridAZReport() {
    this.isClickedAZReport = true;
    console.log('resetGridAZReport all grids');

    Object.values(this.gridApis).forEach(api => {
      api.setFilterModel(null);
      api.deselectAll();
      api.refreshCells();
      api.resetColumnState();
    });
  }
  gridApiTrendAnalysis: any;
  gridColumnApiTrendAnalysis: any;
  onGridReadyForTrendAnalysis(params: any) {
    this.gridApiTrendAnalysis = params.api;
    this.gridColumnApiTrendAnalysis = params.columnApi;
  }
  //Trend Analysis Report
  // Trend Analysis Report
  isClickedTrendAnalysisReport = false;

  resetGridTrendAnalysis() {
    this.isClickedTrendAnalysisReport = true;
    console.log(this.gridApiTrendAnalysis);

    if (this.gridApiTrendAnalysis) {
      this.gridApiTrendAnalysis.setFilterModel(null); // Clear filters
      this.gridApiTrendAnalysis.paginationGoToFirstPage(); // Reset pagination
      this.gridApiTrendAnalysis.refreshCells(); // Refresh cells
      this.gridApiTrendAnalysis.deselectAll(); // Deselect all
      this.gridApiTrendAnalysis.setGridOption('quickFilterText', ''); // Clear quick filter

      // ✅ Reset swapped column order
      this.gridApiTrendAnalysis.resetColumnState();
    }
  }

  //Score Given By You Report
  allGridApis: any[] = [];
  onGridReadyForScoreGiven(params: any) {
    this.allGridApis.push(params.api); // har grid ka api save karna
  }
  isClickedScoreGiven = false;
  resetGridScoreGiven() {
    this.isClickedScoreGiven = true;

    this.allGridApis.forEach(api => {
      api.setFilterModel(null);
      api.paginationGoToFirstPage();
      api.onFilterChanged();
      api.onSortChanged();
      api.refreshClientSideRowModel('everything');
      api.resetColumnState();
    });
  }

  // gridApis: { [key: number]: GridApi } = {};

  onGridReadyForAZReport(params: GridReadyEvent, index: number) {
    this.gridApis[index] = params.api;
  }

  onCelledClicked(event: any) {
    console.log(event.colDef?.field);
    this.selectedRow = event.data;

    if (event.colDef?.field == undefined) {
      this.isDetailsOpen = false;
      console.log('undefined call');
    } else {
      this.isDetailsOpen = true;
    }
  }
  // --------------------------------AG GRID CODE---------------------------------------------------------

  // ----------------------------------
  Scoregivenbyyoureport() {
    //For Score Given by You Report
    this.ScoreGivenByYouReportColumnDef = [
      {
        headerName: 'Competency/OEQ',
        field: 'competencyName',
        minWidth: 380,
        filter: 'agSetColumnFilter',
        rowSpan: (params: any) => params.data?.rowSpan || 1,
        cellClass: 'cell-span'
      },
      { headerName: 'Type (open/ rating)', minWidth: 380, filter: 'agSetColumnFilter', field: 'questionType' },
      {
        headerName: 'Question',
        minWidth: 380,
        filter: 'agSetColumnFilter',
        field: 'question',
        onCellClicked: (params: any) => {
          if (typeof params.value === 'string' && params.value.trim() !== '') {
            params.context.componentParent.openCommentModal(params.value, 'Question');
          }
        }
      },
      {
        headerName: 'Score  (WT 10)',
        minWidth: 380,
        filter: 'agSetColumnFilter',
        field: 'score',
        onCellClicked: (params: any) => {
          if (typeof params.value === 'string' && params.value.trim() !== '') {
            params.context.componentParent.openCommentModal(params.value, 'Score  (WT 10)');
          }
        }
      }
    ];

    //For Trend Analysis Report
    this.trendAnalysisReportColumnDef = [
      {
        headerName: 'Year',
        field: 'year',
        minWidth: 305,
        filter: 'agSetColumnFilter',
        rowSpan: (params: any) => params.data?.rowSpan || 1,
        cellClass: 'cell-span',
        valueGetter: (params: any) => {
          if (params.data.fromYear == params.data.toYear) {
            return params.data.fromYear;
          } else {
            const year = params.data.toYear;
            return params.data.fromYear + ' - ' + year.toString().slice(-2);
          }
        }
      },
      { headerName: 'Name of 360 Review', minWidth: 305, filter: 'agSetColumnFilter', field: 'reviewName' },
      {
        headerName: 'Start Date',
        field: 'startDate',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 305,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true, // ✅ AND/OR hide
          maxNumConditions: 1, // ✅ ek condition
          browserDatePicker: true // ✅ sirf date picker
        }
      },
      {
        headerName: 'End Date',
        field: 'endDate',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 305,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true, // ✅ AND/OR hide
          maxNumConditions: 1, // ✅ ek condition
          browserDatePicker: true // ✅ sirf date picker
        }
      },
      { headerName: 'Final Score', minWidth: 305, filter: 'agSetColumnFilter', field: 'finalScore' }
    ];

    this.trendAnalysisCompetencyColumnDef = [
      {
        headerName: 'Year',
        field: 'year',
        minWidth: 305,
        filter: 'agSetColumnFilter',
        rowSpan: (params: any) => params.data?.rowSpan || 1,
        cellClass: 'cell-span',
        valueGetter: (params: any) => {
          if (params.data.fromYear == params.data.toYear) {
            return params.data.fromYear;
          } else {
            const year = params.data.toYear;
            return params.data.fromYear + ' - ' + year.toString().slice(-2);
          }
        }
      },
      { headerName: 'Competency', minWidth: 380, filter: 'agSetColumnFilter', field: 'competencyName' },
      { headerName: 'Score', minWidth: 380, filter: 'agSetColumnFilter', field: 'score' }
    ];
  }

  prepareGridData(competencyList: any[]) {
    let rows: any[] = [];
    competencyList.forEach((c: any) => {
      c.questions.forEach((q: any, index: number) => {
        rows.push({
          competencyName: index === 0 ? c.competencyName : null, // show once
          rowSpan: index === 0 ? c.questions.length : 1, // rowspan logic
          questionType: q.questionType,
          question: q.question,
          score: q.score
        });
      });
    });
    return rows;
  }

  // ---------------------DUMP REPORT------------------

  // ---------- Columns ----------
  prepareColumns() {
    this.columnDefsForDumpReport = [
      {
        headerName: 'Reviewer (list of all people for whom the selected was a P2P/Lead)',
        field: 'receiverName',
        pinned: 'left',
        minWidth: 250,
        filter: 'agSetColumnFilter'
      },
      {
        headerName: 'Feedback giver',
        field: 'feedbackGiverName',
        pinned: 'left',
        minWidth: 180,
        filter: 'agSetColumnFilter'
      },
      {
        headerName: 'Relation by reviewer and stakeholder (x)',
        field: 'relation',
        pinned: 'left',
        minWidth: 180,
        filter: 'agSetColumnFilter'
      },
      // competency + questions
      ...this.getDumpReportListData[0].columns.map((col: any) => {
        return {
          headerName: col.competencyName,
          children: col.questions.map((q: string) => ({
            headerName: q,
            field: `${col.competencyName}_${q}`,
            minWidth: 10,
            filter: 'agSetColumnFilter',
            onCellClicked: (params: any) => {
              if (typeof params.value === 'string' && params.value.trim() !== '') {
                params.context.componentParent.openCommentModal(params.value, col.competencyName);
              }
            }
          }))
        };
      })
    ];
  }

  // ---------- Rows ----------
  prepareRows(arrDumpReportListData: any) {
    console.log('---------------------------888--------------', arrDumpReportListData);
    const data = arrDumpReportListData[0].data; // <- aapke case me object hai, [0] nahi
    this.rowDataForDumpReport = data.map((feedback: any) => {
      const row: any = {
        receiverName: feedback.receiverName,
        feedbackGiverName: feedback.feedbackGiverName,
        relation: feedback.relation
      };

      // columns ke liye loop
      arrDumpReportListData[0].columns.forEach((col: any) => {
        col.questions.forEach((q: any) => {
          // competencyScores me se current competency find karo
          const comp = feedback.competencyScores.find((c: any) => c.competencyName === col.competencyName);

          // agar competency mili toh uske andar questionScores find karo
          const questionScore = comp?.questionScores.find((qs: any) => qs.question === q);

          // score assign karo
          row[`${col.competencyName}_${q}`] = questionScore?.score || '-';
        });
      });

      return row;
    });
  }

  // ---------- Total Row ----------
  getTotalRow(getDumpReportListData: any) {
    console.log('-------------------------948-----------', getDumpReportListData);

    const totalRow: any = {
      receiverName: 'Total',
      feedbackGiverName: '',
      relation: ''
    };

    getDumpReportListData[0]?.columns.forEach((col: any) => {
      col.questions.forEach((q: string) => {
        let sum = 0;
        let count = 0;
        this.rowDataForDumpReport.forEach((row: any) => {
          const val = row[`${col.competencyName}_${q}`];
          if (val !== '-' && !isNaN(val)) {
            sum += Number(val);
            count++;
          }
        });
        totalRow[`${col.competencyName}_${q}`] = sum > 0 ? sum : 0;
      });
    });

    return [totalRow];
  }

  // call this function whenever you want to refresh total row
  updatePinnedBottomRow() {
    const totalRow: any = {
      receiverName: 'Total',
      feedbackGiverName: '',
      relation: ''
    };

    const visibleRows: any[] = [];
    this.gridApi.forEachNodeAfterFilterAndSort((node: any) => {
      if (!node.group && !node.rowPinned) {
        visibleRows.push(node.data);
      }
    });

    this.getDumpReportListData[0].columns.forEach((col: any) => {
      col.questions.forEach((q: string) => {
        let sum = 0;

        visibleRows.forEach((row: any) => {
          const val = row[`${col.competencyName}_${q}`];
          if (val !== '-' && !isNaN(val)) {
            sum += Number(val);
          }
        });

        totalRow[`${col.competencyName}_${q}`] = sum > 0 ? sum : 0;
      });
    });

    // ✅ Set pinned bottom row dynamically
    this.gridApi.setPinnedBottomRowData([totalRow]);
  }

  // setPinnedBottomRow() {
  //   const totalRow: any = {
  //     receiverName: 'Total',
  //     feedbackGiverName: '',
  //     relation: ''
  //   };

  //   this.getDumpReportListData.columns.forEach((col: any) => {
  //     col.questions.forEach((q: string) => {
  //       const field = `${col.competencyName}_${q}`;
  //       totalRow[field] = this.rowDataForDumpReport.reduce((sum: number, row: any) => {
  //         const val = parseFloat(row[field]);
  //         return !isNaN(val) ? sum + val : sum;
  //       }, 0);
  //     });
  //   });

  //   this.gridApi.setPinnedBottomRowData([totalRow]);
  // }

  // -------------------------------------

  // ----------------------------Start AZ-REPORT------------------------------
  // your original incoming data

  // We'll prepare one grid config per item and store them in an array
  atozGrids: Array<{
    columns: ColDef[];
    rows: any[];
    pinnedBottom: any[];
    gridId: string;
  }> = [];

  // call this after AtoZReportListData is ready (e.g. after API)
  initAtoZGrids() {
    this.atozGrids = this.AtoZReportListData.map((item: any, idx: any) => {
      const columns = this.prepareAZColumns();
      const { rows, totalQuestions } = this.prepareRowsForItem(item);
      const pinnedBottom = this.preparePinnedBottomRow(item);
      return {
        columns,
        rows,
        pinnedBottom,
        gridId: `grid-${idx}`
      };
    });
  }
  // initAtoZGrids() {
  //   this.atozGrids = this.AtoZReportListData.map((item: any, idx: number) => {
  //     const { rows, totalQuestions, finalScoreOf360 } = this.prepareRowsForItems(item);
  //     console.log(rows);
  //     console.log('Final Score injected into grid:', finalScoreOf360);

  //     item.finalScoreOf360 = finalScoreOf360;

  //     // ✅ Inject into first row
  //     if (rows.length > 0) {
  //       rows[0].finalScoreOf360 = finalScoreOf360;
  //       rows[0].finalScore360RowSpan = rows.length;

  //       for (let i = 1; i < rows.length; i++) {
  //         rows[i].finalScoreOf360 = null;
  //         rows[i].finalScore360RowSpan = 0;
  //       }
  //     }

  //     const columns = this.prepareAZColumns();
  //     const pinnedBottom = this.preparePinnedBottomRow(item);

  //     return {
  //       columns,
  //       rows,
  //       pinnedBottom,
  //       gridId: `grid-${idx}`
  //     };
  //   });
  // }

  // calcFinal360Score(item: any): number {
  //   const scores = item.questions.map((q: any) => q.finalScoreQuestionWise).filter(Boolean);
  //   return scores.length ? scores.reduce((a: number, b: number) => a + b, 0) / scores.length : null;
  // }
  calcFinal360Score(user: any): number {
    const scores: number[] = user.competency.map((c: any) => c.finalScoreCompetencyWise).filter((s: any): s is number => s !== null && s !== undefined);

    return scores.length ? scores.reduce((a, b) => a + b, 0) / scores.length : 0;
  }

  // ---------- build column definitions (shared for each grid) ----------
  // prepareAZColumns(): ColDef[] {
  //   console.log("stakeHoldersArrayForSetup-----------------",this.stakeHoldersArrayForSetup);

  //   return [
  //     {
  //       headerName: 'Competency/OEQ',
  //       field: 'competencyName',
  //       pinned: 'left',   // freeze
  //       filter: 'agSetColumnFilter',
  //       rowSpan: (params: any) => params.data?.competencyRowSpan || 1,
  //       cellClass: 'cell-competency',
  //       cellRenderer: (params: any) => params.value || '',
  //       minWidth: 220,
  //     },
  //     {
  //       headerName: 'Type (open/ rating)',
  //       field: 'questionType',
  //       pinned: 'left',   // freeze
  //       minWidth: 160,
  //       filter: 'agSetColumnFilter',
  //       cellRenderer: (params: any) => params.value || ''
  //     },
  //     {
  //       headerName: 'Question',
  //       field: 'question',
  //       minWidth: 300,
  //       filter: 'agSetColumnFilter',
  //       cellRenderer: (params: any) => params.value || '',
  //       onCellClicked: (params: any) => {
  //         if (typeof params.value === 'string' && params.value.trim() !== '') {
  //           params.context.componentParent.openCommentModal(
  //             params.value,
  //             'Question'
  //           );
  //         }
  //       }
  //     },
  //     {
  //       headerName: `Score by self (20)`,
  //       field: 'selfScore',
  //       minWidth: 190,
  //       filter: 'agSetColumnFilter',
  //       cellStyle: { textAlign: 'center' },
  //       cellRenderer: (params: any) => this.scoreCellRenderer(params),
  //       onCellClicked: (params: any) => {
  //         if (typeof params.value === 'string' && params.value.trim() !== '') {
  //           params.context.componentParent.openCommentModal(
  //             params.value,
  //             'Score by self (20)'
  //           );
  //         }
  //       }
  //     },
  //     {
  //       headerName: `Score by peer (10)`,
  //       field: 'peerScore',
  //       minWidth: 190,
  //       cellStyle: { textAlign: 'center' },
  //       filter: 'agSetColumnFilter',
  //       cellRenderer: (params: any) => this.scoreCellRenderer(params),
  //       onCellClicked: (params: any) => {
  //         if (typeof params.value === 'string' && params.value.trim() !== '') {
  //           params.context.componentParent.openCommentModal(
  //             params.value,
  //             'Score by peer (10)'
  //           );
  //         }
  //       }
  //     }
  //     ,
  //     {
  //       headerName: `Score by subordinate (10)`,
  //       field: 'subordinateScore',
  //       minWidth: 240,
  //       cellStyle: { textAlign: 'center' },
  //       filter: 'agSetColumnFilter',
  //       cellRenderer: (params: any) => this.scoreCellRenderer(params),
  //       onCellClicked: (params: any) => {
  //         if (typeof params.value === 'string' && params.value.trim() !== '') {
  //           params.context.componentParent.openCommentModal(
  //             params.value,
  //             'Score by subordinate (10)'
  //           );
  //         }
  //       }
  //     },
  //     {
  //       headerName: `Score by superior (20)`,
  //       field: 'superiorScore',
  //       minWidth: 220,
  //       cellStyle: { textAlign: 'center' },
  //       filter: 'agSetColumnFilter',
  //       cellRenderer: (params: any) => this.scoreCellRenderer(params),
  //       onCellClicked: (params: any) => {
  //         if (typeof params.value === 'string' && params.value.trim() !== '') {
  //           params.context.componentParent.openCommentModal(
  //             params.value,
  //             'Score by superior (20)'
  //           );
  //         }
  //       }
  //     },
  //     {
  //       headerName: `Score by Internal Customer (20)`,
  //       field: 'internalCustomerScore',
  //       minWidth: 280,
  //       cellStyle: { textAlign: 'center' },
  //       filter: 'agSetColumnFilter',
  //       cellRenderer: (params: any) => this.scoreCellRenderer(params),
  //       onCellClicked: (params: any) => {
  //         if (typeof params.value === 'string' && params.value.trim() !== '') {
  //           params.context.componentParent.openCommentModal(
  //             params.value,
  //             'Score by Internal Customer (20)'
  //           );
  //         }
  //       }
  //     },
  //     {
  //       headerName: `Score by External Customer (20)`,
  //       field: 'externalCustomerScore',
  //       minWidth: 280,
  //       cellStyle: { textAlign: 'center' },
  //       filter: 'agSetColumnFilter',
  //       cellRenderer: (params: any) => this.scoreCellRenderer(params),
  //       onCellClicked: (params: any) => {
  //         if (typeof params.value === 'string' && params.value.trim() !== '') {
  //           params.context.componentParent.openCommentModal(
  //             params.value,
  //             'Score by External Customer (20)'
  //           );
  //         }
  //       }
  //     },
  //     {
  //       headerName: 'Final Score Question Wise',
  //       field: 'finalScoreQuestionWise',
  //       minWidth: 240,
  //       filter: 'agSetColumnFilter',
  //       cellStyle: { textAlign: 'center', fontWeight: '600' },
  //       valueFormatter: (params: any) => {
  //         if (params.value && !isNaN(params.value)) {
  //           return Number(params.value).toFixed(2);
  //         }
  //         return params.value || '';  // 👈 agar undefined/null hai toh blank
  //       }
  //     },
  //     {
  //       headerName: 'Final Score Competency Wise',
  //       field: 'finalScoreCompetencyWise',
  //       minWidth: 260,
  //       filter: 'agSetColumnFilter',
  //       rowSpan: (params: any) => params.data?.finalScoreCompetencyRowSpan || 1,
  //       cellStyle: { textAlign: 'center', fontWeight: '600' },
  //       valueFormatter: (params: any) => {
  //         if (params.value && !isNaN(params.value)) {
  //           return Number(params.value).toFixed(2);
  //         }
  //         return params.value || '';  // 👈 agar undefined/null hai toh blank
  //       }
  //     },

  //     {
  //       headerName: 'Final Score',
  //       field: 'finalScoreOf360',
  //       minWidth: 190,
  //       rowSpan: params => {
  //         // Only first row spans all rows
  //         return params.node?.rowIndex === 0 ? params.api.getDisplayedRowCount() : 1;
  //       },
  //       valueFormatter: (params: any) => {
  //         if (params.value && !isNaN(params.value)) {
  //           return Number(params.value).toFixed(2);
  //         }
  //         return params.value || '';  // 👈 agar undefined/null hai toh blank
  //       },
  //       cellStyle: {
  //         textAlign: 'center',
  //         fontWeight: '800',
  //         background: 'rgb(244, 244, 244)',
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center'
  //       }
  //     }

  //   ];
  // }

  prepareAZColumns(): ColDef[] {
    console.log('stakeHoldersArrayForSetup-----------------', this.stakeHoldersArrayForSetup);

    // Base (always visible) columns
    const baseColumns: ColDef[] = [
      {
        headerName: 'Competency/OEQ',
        field: 'competencyName',
        pinned: 'left',
        filter: 'agSetColumnFilter',
        rowSpan: (params: any) => params.data?.competencyRowSpan || 1,
        cellClass: 'cell-competency',
        cellRenderer: (params: any) => params.value || '',
        minWidth: 220
      },
      {
        headerName: 'Type (open/ rating)',
        field: 'questionType',
        pinned: 'left',
        minWidth: 160,
        filter: 'agSetColumnFilter',
        cellRenderer: (params: any) => params.value || ''
      },
      {
        headerName: 'Question',
        field: 'question',
        minWidth: 300,
        filter: 'agSetColumnFilter',
        cellRenderer: (params: any) => params.value || '',
        onCellClicked: (params: any) => {
          if (typeof params.value === 'string' && params.value.trim() !== '') {
            params.context.componentParent.openCommentModal(params.value, 'Question');
          }
        }
      }
    ];

    // Dynamically generate stakeholder columns based on selection
    const stakeholderColumns: ColDef[] = this.stakeHoldersArrayForSetup
      ?.filter((s: any) => s.selected)
      .map((s: any) => ({
        headerName: `Score by ${s.name} (${s.weightage})`,
        field: this.getScoreFieldName(s.name),
        minWidth: 220,
        filter: 'agSetColumnFilter',
        cellStyle: { textAlign: 'center' },
        cellRenderer: (params: any) => this.scoreCellRenderer(params),
        onCellClicked: (params: any) => {
          if (typeof params.value === 'string' && params.value.trim() !== '') {
            params.context.componentParent.openCommentModal(params.value, `Score by ${s.name} (${s.weightage})`);
          }
        }
      }));

    // Final summary columns
    const finalColumns: ColDef[] = [
      {
        headerName: 'Final Score Question Wise',
        field: 'finalScoreQuestionWise',
        minWidth: 240,
        filter: 'agSetColumnFilter',
        cellStyle: { textAlign: 'center', fontWeight: '600' },
        valueFormatter: (params: any) => (params.value && !isNaN(params.value) ? Number(params.value).toFixed(2) : params.value || '')
      },
      {
        headerName: 'Final Score Competency Wise',
        field: 'finalScoreCompetencyWise',
        minWidth: 260,
        filter: 'agSetColumnFilter',
        rowSpan: (params: any) => params.data?.finalScoreCompetencyRowSpan || 1,
        cellStyle: { textAlign: 'center', fontWeight: '600' },
        valueFormatter: (params: any) => (params.value && !isNaN(params.value) ? Number(params.value).toFixed(2) : params.value || '')
      },
      {
        headerName: 'Final Score',
        field: 'finalScoreOf360',
        minWidth: 190,
        rowSpan: (params: any) => (params.node?.rowIndex === 0 ? params.api.getDisplayedRowCount() : 1),
        valueFormatter: (params: any) => (params.value && !isNaN(params.value) ? Number(params.value).toFixed(2) : params.value || ''),
        cellStyle: {
          textAlign: 'center',
          fontWeight: '800',
          background: 'rgb(244, 244, 244)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }
    ];

    // Combine everything
    return [...baseColumns, ...stakeholderColumns, ...finalColumns];
  }

  // Helper function to match stakeholder name to field name
  getScoreFieldName(name: string): string {
    switch (name) {
      case 'Self':
        return 'selfScore';
      case 'Superior':
        return 'superiorScore';
      case 'Peer':
        return 'peerScore';
      case 'Subordinate':
        return 'subordinateScore';
      case 'Internal Customer':
        return 'internalCustomerScore';
      case 'External Customer':
        return 'externalCustomerScore';
      default:
        return '';
    }
  }

  // helper renderer — rating vs open-ended
  scoreCellRenderer(params: any) {
    const qType = params.data?.questionType;
    const value = params.value ?? '';
    if (qType === 'Open Ended') {
      // show multi-line text area look (readonly) — pure HTML
      const safeText = ('' + value).replace(/</g, '&lt;').replace(/>/g, '&gt;');

      return `<div style="white-space:pre-wrap; max-width:260px; font-size:13px;">${safeText || ''}</div>`;
    }

    // rating based — show number (or dash)
    return `<div>${value || ''}</div>`;
  }

  prepareRowsForItems(item: any) {
    const rows: any[] = [];

    if (!item?.competency?.length) {
      return { rows: [], totalQuestions: 0, finalScoreOf360: null };
    }

    const weightMap = { self: 20, peer: 10, subordinate: 10, superior: 20, internal: 20, external: 20 };
    const competencyScores: number[] = [];

    // Convert any value into array of numbers (empty → [])
    const toNumArray = (val: any): number[] => {
      if (val == null || val === '') return [];

      if (Array.isArray(val)) {
        return val.map(v => Number(v)).filter(v => !isNaN(v));
      }

      return [Number(val)].filter(v => !isNaN(v));
    };

    // Flatten all questions into rows
    item.competency.forEach((comp: any) => {
      if (!comp.questions?.length) return;

      const questionScores: number[] = [];

      comp.questions.forEach((q: any) => {
        // const strPeerScore = (typeof q.peerScore === 'string') ?? q.peerScore;
        // console.log(strPeerScore)
        let selfScore = toNumArray(q.selfScore);
        let peerScore = toNumArray(q.peerScore);
        let subScore = toNumArray(q.subordinateScore);
        let supScore = toNumArray(q.superiorScore);
        let intScore = toNumArray(q.internalCustomerScore);
        let extScore = toNumArray(q.externalCustomerScore);

        let sum = 0,
          total = 0;

        if (selfScore.length) {
          sum += selfScore[0] * weightMap.self;
          total += weightMap.self;
        } else if (typeof q.selfScore === 'string') {
          selfScore = q.selfScore;
        }
        if (peerScore.length) {
          sum += (peerScore.reduce((a, b) => a + b, 0) / peerScore.length) * weightMap.peer;
          total += weightMap.peer;
        } else if (typeof q.peerScore === 'string') {
          peerScore = q.peerScore;
        }

        if (subScore.length) {
          sum += (subScore.reduce((a, b) => a + b, 0) / subScore.length) * weightMap.subordinate;
          total += weightMap.subordinate;
        } else if (typeof q.subordinateScore === 'string') {
          subScore = q.subordinateScore;
        }
        if (supScore.length) {
          sum += (supScore.reduce((a, b) => a + b, 0) / supScore.length) * weightMap.superior;
          total += weightMap.superior;
        } else if (typeof q.superiorScore === 'string') {
          supScore = q.superiorScore;
        }
        if (intScore.length) {
          sum += (intScore.reduce((a, b) => a + b, 0) / intScore.length) * weightMap.internal;
          total += weightMap.internal;
        } else if (typeof q.internalCustomerScore === 'string') {
          intScore = q.internalCustomerScore;
        }
        if (extScore.length) {
          sum += (extScore.reduce((a, b) => a + b, 0) / extScore.length) * weightMap.external;
          total += weightMap.external;
        } else if (typeof q.externalCustomerScore === 'string') {
          extScore = q.externalCustomerScore;
        }

        const finalScoreQ = total > 0 ? sum / total : 0;
        questionScores.push(finalScoreQ);

        rows.push({
          competencyName: comp.competencyName,
          competencyRowSpan: comp.questions.length,
          questionType: q.questionType || 'Rating Based',
          question: q.question,
          selfScore,
          peerScore,
          subordinateScore: subScore,
          superiorScore: supScore,
          internalCustomerScore: intScore,
          externalCustomerScore: extScore,
          finalScoreQuestionWise: finalScoreQ,
          finalScoreCompetencyWise: null,
          finalScoreOf360: null,
          finalScore360RowSpan: undefined
        });
      });
      console.log('*-------------1368---------', rows);
      // Competency average
      const compScore = questionScores.length ? questionScores.reduce((a, b) => a + b, 0) / questionScores.length : 0;
      competencyScores.push(compScore);

      // Set competency-wise score on first question of this competency
      const startIndex = rows.length - comp.questions.length;
      rows[startIndex].finalScoreCompetencyWise = compScore;
      rows[startIndex].finalScoreCompetencyRowSpan = comp.questions.length;
    });

    // Calculate final 360 score
    const numericCompetencyScores = competencyScores.filter(s => !isNaN(s));
    const finalScoreOf360 = numericCompetencyScores.length ? numericCompetencyScores.reduce((a, b) => a + b, 0) / numericCompetencyScores.length : 0;

    // Assign finalScoreOf360 to the first numeric row
    const firstNumericRow = rows.find(r => r.finalScoreQuestionWise != null && !isNaN(r.finalScoreQuestionWise));
    if (firstNumericRow) {
      firstNumericRow.finalScoreOf360 = finalScoreOf360;
      firstNumericRow.finalScore360RowSpan = rows.length;

      // All other rows
      rows.forEach(r => {
        if (r !== firstNumericRow) {
          r.finalScoreOf360 = null;
          r.finalScore360RowSpan = undefined;
        }
      });
    }

    return { rows, totalQuestions: rows.length, finalScoreOf360 };
  }

  // ---------- prepare rows (for one item) ----------
  prepareRowsForItem(item: any) {
    // item.competency is array of { competencyName, questions: [ {question, questionType, ... } ] }
    const rows: any[] = [];
    let totalQuestions = 0;

    for (const comp of item.competency || []) {
      const questions = comp.questions || [];
      totalQuestions += questions.length;

      for (let qi = 0; qi < questions.length; qi++) {
        const q = questions[qi];

        const row: any = {
          competencyName: comp.competencyName,
          questionType: q.questionType,
          question: q.question,
          selfScore: q.selfScore ?? '',
          peerScore: q.peerScore ?? '',
          subordinateScore: q.subordinateScore ?? '',
          superiorScore: q.superiorScore ?? '',
          internalCustomerScore: q.internalCustomerScore ?? '',
          externalCustomerScore: q.externalCustomerScore ?? '',
          finalScoreQuestionWise: q.finalScoreQuestionWise ?? ''
        };

        // mark rowspan values only on the FIRST question row of each competency
        if (qi === 0) {
          row.competencyRowSpan = questions.length || 1;
          row.finalScoreCompetencyRowSpan = questions.length || 1;
        } else {
          row.competencyRowSpan = 1;
          row.finalScoreCompetencyRowSpan = 1;
        }

        rows.push(row);
      } // questions loop
    } // comp loop

    // Final Score of this 360 should span all question rows (show only on very first row)
    if (rows.length > 0) {
      rows[0].finalScoreOf360RowSpan = rows.length;
      // assign the finalScoreOf360 value to the first row only
      rows[0].finalScoreOf360 = item.finalScoreOf360 ?? '';
    }

    // Also copy competency-level final value into the first row of each competency:
    // We already set finalScoreCompetencyRowSpan; now put the value at first row of competency
    let rowIdx = 0;
    for (const comp of item.competency || []) {
      const questions = comp.questions || [];
      if (questions.length > 0) {
        rows[rowIdx].finalScoreCompetencyWise = comp.finalScoreCompetencyWise ?? '';
      }
      rowIdx += questions.length;
    }

    return { rows, totalQuestions };
  }

  // ---------- pinned bottom row for final stakeholder-wise summary ----------
  preparePinnedBottomRow(item: any) {
    // build pinned bottom row with only the final summary columns populated
    const pinned: any = {
      competencyName: 'Final Score stakeholder Wise',
      questionType: '',
      question: '',
      selfScore: item.finalSelfScore ?? '',
      peerScore: item.finalPeerScore ?? '',
      subordinateScore: item.finalSubordinateScore ?? '',
      superiorScore: item.finalSuperiorScore ?? '',
      internalCustomerScore: item.finalInternalCustomerScore ?? '',
      externalCustomerScore: item.finalExternalCustomerScore ?? '',
      finalScoreQuestionWise: '',
      finalScoreCompetencyWise: '',
      finalScoreOf360: ''
    };
    return [pinned];
  }

  // grid apis map (if you need per-grid API)

  // columnApis: { [id: string]: ColumnApi } = {};
  // ---------- call when grid is ready (per-grid) ----------
  onGridReadyForAZReprot(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    // don't expect params.columnApi — use gridApi methods instead
  }

  // ----------------------------End AZ-REPORT------------------------------

  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      if (params?.operation == 'Setup') {
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
          this.showSetupPopup = true;
          this.selectedTypeTabName = '';
          this.getYearsOfCompany();
          if (params?.id) {
            this.selectedReviewID = params?.id;
            this.selectedYear = params?.year;
            this.selectedReviewID = Number(this.selectedReviewID);
            this.getReviewByID();
            // this.getReview360ByIdAndUser();
          }
        }
      } else {
        this.showSetupPopup = false;
        this.selectedTypeTabIndex = params?.tabIndex;
        this.getYearsOfCompany();
      }
    });
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/threeSixtyDegree', { operation: operation }]);
  }

  onClickRedirectToDashboard() {
    this.router.navigate(['/home/hrportal/threeSixtyDegree']);
  }

  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/threeSixtyDegree/logs']);
  }

  tabTypeChanged(event: MatTabChangeEvent): void {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
    if (this.selectedTypeTabName == 'Participate in 360 Review') {
      this.selectedSubTab = null;
      this.reviewNamesOfUser();
    }
    if (this.selectedTypeTabName == 'Reports') {
      this.reviewNamesActiveAndCompleted();
      this.selectedSubTab = 'A-Z report';
    }
    if (this.selectedTypeTabName == 'Dashboard') {
      this.reviewNamesActiveAndCompleted();

      this.selectedSubTab = null;
    }
    if (this.selectedTypeTabName == '360 Review Master') {
      this.selectedSubTab = null;
    }
  }

  // -----------------------------------------Setup------------------------------------------
  onClickCancelSetup() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to Cancel Review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['/home/hrportal/threeSixtyDegree']);
      }
    });
  }

  onClickSaveSetup() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to Save 360 Review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateReview();
      }
    });
  }

  onClickPublishBtn() {
    if (this.isPublished) {
      const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
        maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
        data: {
          msg: '360 Review is alreay published.',
          btn2: 'OK',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        }
      });
      return;
    }
    var flag = true;
    if (!this.isEditActive) {
      if (this.selectedBandForSetup.length == 0) {
        flag = false;
      }
      if (this.selectedFunctionForSetup.length == 0) {
        flag = false;
      }
      if (this.selectedEmployeeId.length == 0) {
        flag = false;
      }
      if (this.selectedGradeForSetup.length == 0) {
        flag = false;
      }
      if (this.selectedLocationForSetup.length == 0) {
        flag = false;
      }
      // if (!this.externalCustomerWeightage) { flag = false };
      if (this.intructionList.length == 0) {
        flag = false;
      }

      if (!this.invitationEmailBody) {
        flag = false;
      }
      if (!this.invitationEmailSubject) {
        flag = false;
      }
      if (!this.submissionEmailBody) {
        flag = false;
      }
      if (!this.reviewDateOfJoining) {
        flag = false;
      }
      if (!this.submissionEmailSubject) {
        flag = false;
      }

      //  if (!this.internalCustomerWeightage) { flag = false };
      //     if (!this.peerWeightage) { flag = false };
      //     if (!this.selfWeightage) { flag = false };
      //     if (!this.subordinateWeightage) { flag = false };
      //     if (!this.superiorWeightage) { flag = false };

      if (this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based' && ele.rating == null)) {
        flag = false;
      }
      if (this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based' && ele.ratingDefinition == '')) {
        flag = false;
      }
      var tempRatings: any = [];
      this.isRatingDuplicate = false;
      for (let item of this.ratingList) {
        if (tempRatings.includes(item.rating)) {
          flag = false;
          this.isRatingDuplicate = true;
          break;
        }
        tempRatings.push(item.rating);
      }
      var arraygetCompetencyList: any = [];
      this.getCompetencyList.forEach((ele: any) => {
        ele.competencies.forEach((ele1: any) => {
          let obj = {
            band: ele.band,
            competencyName: ele1.competencyName,
            department: ele.department,
            id: ele1.competencyId || null,
            questions: ele1.questions
          };
          arraygetCompetencyList.push(obj);
        });
      });

      if (arraygetCompetencyList.some((item: any) => item.questions.some((q: any) => q.question === ''))) {
        flag = false;
      }
    }

    if (flag == true) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
        maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
        data: {
          msg: 'Are you sure you want to Publish 360 Review?',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.publish360Review();
        }
      });
    } else {
      const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
        maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
        data: {
          msg: 'Please fill all mandetory fields.',
          btn2: 'OK',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        }
      });
    }
  }

  publish360Review() {
    // this.loader.simpleLoader();
    this.httpService.callGetService(this.config.publish360ById + this.selectedReviewID).subscribe(
      (data: any) => {
        this.loader.dismissLoader();
        if (data?.status) {
          this.getReviewByID();
          // this.getReview360ByIdAndUser();
          const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
            maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
        } else {
          const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
            maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
        }
      },
      error => {
        if (error) {
          const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
            maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
            data: {
              msg: 'Please fill all mandetory fields.',
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
          successdialogRef.afterClosed().subscribe((result: any) => {
            this.loader.dismissLoader();
          });
        }
      }
    );
  }

  onClickOpenCreateReviewPopup(popupName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      popupName: popupName,
      selectedYear: this.selectedYear,
      selectedEmployees: this.selectedEmployeeId,
      stakeHoldersArrayForSetup: this.stakeHoldersArrayForSetup,
      selectedReviewID: this.selectedReviewID,
      stakeholdersArray: this.stakeholdersArray,
      subordinateWeightage: this.subordinateWeightage,
      superiorWeightage: this.superiorWeightage,
      selfWeightage: this.selfWeightage,
      peerWeightage: this.peerWeightage,
      externalCustomerWeightage: this.externalCustomerWeightage,
      internalCustomerWeightage: this.internalCustomerWeightage,
      getCompetencyList: this.getCompetencyList,
      isOpenEnded: this.isOpenEnded,
      isRatingBased: this.isRatingBased,
      isExternalCustomerEnabled: this.isExternalCustomerEnabled,
      isPublished: this.isPublished
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ThreeSixtyDegreePopupsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (popupName == 'Create 360 Review') {
        this.getListOfReviewName();
      }
      if (popupName == 'Stakeholder Identification') {
        console.log('result', result);
        if (result !== undefined) {
          this.externalCustomerWeightage = result?.externalCustomerWeightage;
          this.subordinateWeightage = result?.subordinateWeightage;
          this.superiorWeightage = result?.superiorWeightage;
          this.selfWeightage = result?.selfWeightage;
          this.peerWeightage = result?.peerWeightage;
          this.internalCustomerWeightage = result?.internalCustomerWeightage;
          this.stakeholdersArray = result?.stakeholdersArray;
        }
      }
      if (popupName == 'Create Question') {
        this.getCompetencyList = result?.getCompetencyList;
      }
    });
  }

  onAddStakeHolders() {
    this.isShowSaveBtn = true;
  }

  onSaveStakeHolders() {
    this.isShowSaveBtn = false;
    // this.stakeHoldersArrayForSetup.push({ name: 'External Customer' })
    this.isExternalCustomerEnabled = true;
  }

  // -----------------------------------------Dashboard------------------------------------------
  dashboardPopups() {
    // if (window.innerWidth <= 800) { return; }

    const successdialogRef = this.dialog.open(ThreeSixtyDashboardPopupsComponent, {
      disableClose: true,
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '90%' : '70%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        selectedYear: this.selectedYear,
        stakeHoldersArrayForSetup: this.stakeHoldersArrayForSetup,
        selectedReviewGlobalDashboardID: this.selectedReviewGlobalDashboardID
      }
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  // Competency Wise Graph
  reviewNamesActiveAndCompletedCompetencyWise() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }
    this.selectedReviewCompetencyWiseID = null;
    this.listofReviewNamesActiveAndCompletedCompetencyWise = [];
    const test = this.selectedYearCompetencyWise?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + isEmployee).subscribe((data: any) => {
      this.listofReviewNamesActiveAndCompletedCompetencyWise = [];
      this.bandlistForCompetencyWiseGraph = [];
      this.empListForCompetencyWiseGraph = [];

      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        };
        this.listofReviewNamesActiveAndCompletedCompetencyWise.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedCompetencyWise.length != 0) {
        this.selectedReviewCompetencyWiseID = this.listofReviewNamesActiveAndCompletedCompetencyWise[0].id;
        this.getBandNamesReviewId();
      } else {
        this.selectedReviewCompetencyWiseID = null;
      }
      this.getCompletionStatusGraph();
    });
  }

  getBandNamesReviewId() {
    this.httpService.callGetService(this.config.getBandNamesReviewId + this.selectedReviewCompetencyWiseID).subscribe((data: any) => {
      this.bandlistForCompetencyWiseGraph = data?.data;
      console.log('bandlist is here...', this.bandlistForCompetencyWiseGraph);

      this.selectedBandCompetencyWiseGraph = data?.data[0];
      console.log('selected competncy...', this.selectedBandCompetencyWiseGraph);

      this.getEmpNamesBy360AndBands();
      this.getCompletionStatusGraph();
    });
  }

  getEmpNamesBy360AndBands() {
    const test = this.selectedYearCompetencyWise?.split('-');
    const request = {
      bands: [this.selectedBandCompetencyWiseGraph],
      reviewId: this.selectedReviewCompetencyWiseID
    };
    this.httpService.callPostService(this.config.getEmpNamesBy360AndBands, request).subscribe((data: any) => {
      if (data?.data) {
        this.empListForCompetencyWiseGraph = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName
          };
          this.empListForCompetencyWiseGraph.push(obj);
        });
        if (this.empListForCompetencyWiseGraph.length != 0) {
          this.selectedEmployeeCompetencyWiseGraph = this.empListForCompetencyWiseGraph[0].id;
          this.getCompletionStatusGraph();
        } else {
          this.selectedEmployeeCompetencyWiseGraph = null;
        }
      }
    });
  }

  getCompletionStatusGraph() {
    this.competencyWiseGraphData = [];
    let bandCompetencyWiseGraph: any;
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      this.selectedEmployeeCompetencyWiseGraph = this.loggedInUserId;
      bandCompetencyWiseGraph = null;
    } else {
      bandCompetencyWiseGraph = this.selectedBandCompetencyWiseGraph;
    }
    const year = this.selectedYearCompetencyWise?.split('-');
    const request = {
      band: bandCompetencyWiseGraph,
      companyId: this.loggedInUserCompanyID,
      competencyId: [],
      fromYear: year[0],
      isComplete: true,
      isTopAnalysis: true,
      reviewId: this.selectedReviewCompetencyWiseID,
      toYear: year[1],
      userId: this.selectedEmployeeCompetencyWiseGraph
    };
    this.httpService.callPostService(this.config.getCompetencyWiseGraph, request).subscribe((data: any) => {
      this.competencyWiseGraphData = [];

      data?.data?.forEach((ele: any) => {
        let obj = {
          value: ele.score,
          name: ele.parameterName
        };
        this.competencyWiseGraphData.push(obj);
      });
      this.switchCompetencyWiseGraphType('bar');
    });
  }

  switchCompetencyWiseGraphType(graphType: string) {
    this.competencyWiseIcon = graphType;
    this.competencyWiseTable = false;

    const dom = document.getElementById('competencyWiseGraph') as HTMLDivElement;
    setTimeout(() => {
      if (!dom) {
        console.warn('competencyWiseGraph container not found yet.');
        return;
      }
      const chartEmpTaskStatus = echarts.init(dom);
      chartEmpTaskStatus.clear();
      if (graphType === 'bar') {
        this.competencyWiseBarGraph(chartEmpTaskStatus);
      }
      if (graphType === 'line') {
        this.competencyWiseLineGraph(chartEmpTaskStatus);
      }
      this.mobileResponsiveService.chartResizeFn(chartEmpTaskStatus);
    }, 800);
  }

  competencyWiseBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['Score'],
        bottom: 0,
        left: 'center'
      },
      xAxis: [
        {
          type: 'category',
          data: this.competencyWiseGraphData.map((ele: any) => ele.name),
          name: 'Competancy',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {}
      },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: this.competencyWiseGraphData.map((ele: any) => ele.value),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          }
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  competencyWiseLineGraph(chartEmpTaskStatus: any) {
    const options = {
      xAxis: [
        {
          type: 'category',
          data: this.competencyWiseGraphData.map((ele: any) => ele.name),
          name: 'Competancy',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false }
      },
      tooltip: {
        trigger: 'axis'
      },
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: this.competencyWiseGraphData.map((ele: any) => ele.value)
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchCompetencyWiseTable() {
    this.competencyWiseIcon = '';
    this.competencyWiseTable = true;
  }

  // Question Wise Graph

  reviewNamesActiveAndCompletedQuestionWise() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }

    this.questionWiseGraphData = [];
    this.listofReviewNamesActiveAndCompletedQuestionWise = [];
    this.competencylistForQuestionWiseGraph = [];
    this.listOfEmpForQuestionWise = [];

    this.selectedReviewQuestionWiseID = null;
    this.selectedCompetencyQuestionWise = null;
    this.selectedEmployeeQuestionWiseGraph = null;

    const test = this.selectedYearQuestionWise?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + isEmployee).subscribe((data: any) => {
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        };
        this.listofReviewNamesActiveAndCompletedQuestionWise.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedQuestionWise.length != 0) {
        this.selectedReviewQuestionWiseID = this.listofReviewNamesActiveAndCompletedQuestionWise[0].id;
        this.getCompetencyNamesBy360Id();
      } else {
        this.selectedReviewQuestionWiseID = null;
      }
    });
    this.getQuestionWiseStatusGraph();
  }

  // getCompetencyNamesBy360Id() {
  //   let flag: any;

  //   if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
  //     flag = true;
  //   } else {
  //     flag = false;
  //   }

  //   this.httpService.callGetService(this.config.getCompetencyNamesBy360Id + this.selectedReviewQuestionWiseID + '/' + flag ).subscribe((data: any) => {
  //     console.log("Data is..............",data);

  //     this.competencylistForQuestionWiseGraph = data?.data;
  //     console.log("COmptencies for manager ,Employee,hod........", this.competencylistForQuestionWiseGraph);

  //     if (this.competencylistForQuestionWiseGraph.length != 0) {
  //       this.selectedCompetencyQuestionWise = data?.data[0].id;
  //       this.getEmpNamesBy360IdQuestionWiseGraph();
  //     } else {
  //       this.selectedCompetencyQuestionWise = null
  //     }
  //   })
  // }

  getCompetencyNamesBy360Id() {
    let flag: any;

    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      flag = false;
    } else {
      flag = false;
    }

    this.httpService.callGetService(this.config.getCompetencyNamesBy360Id + this.selectedReviewQuestionWiseID + '/' + flag).subscribe((data: any) => {
      let competencies = data?.data || [];

      // Only filter for Manager/HOD/Employee
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        const loggedInUser = this.userData.find(u => u.id == this.loggedInUserId);

        if (loggedInUser) {
          competencies = competencies.filter((c: any) => c.band?.trim().toLowerCase() === loggedInUser.band?.trim().toLowerCase() && c.functionName?.trim().toLowerCase() === loggedInUser.functionName?.trim().toLowerCase());
        }
      }

      this.competencylistForQuestionWiseGraph = competencies;

      if (this.competencylistForQuestionWiseGraph.length != 0) {
        this.selectedCompetencyQuestionWise = this.competencylistForQuestionWiseGraph[0].id;
        this.getEmpNamesBy360IdQuestionWiseGraph();
      } else {
        this.selectedCompetencyQuestionWise = null;
      }
    });
  }

  // getEmpNamesBy360IdQuestionWiseGraph() {
  //   let isEmployee: any
  //   if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' ||
  //     this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
  //     isEmployee = false
  //   } else {
  //     isEmployee = true
  //   }
  //   this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewQuestionWiseID + '/' + isEmployee).subscribe((data: any) => {
  //     console.log("dashboard drodpdown employees...",data);

  //     this.listOfEmpForQuestionWise = [];

  //     data?.data?.forEach((ele: any) => {
  //       let obj = {
  //         id: ele.id,
  //         name: ele.firstName + ' ' + ele.lastName
  //       }
  //       this.listOfEmpForQuestionWise.push(obj);
  //     });
  //     if (this.listOfEmpForQuestionWise.length != 0) {
  //       this.selectedEmployeeQuestionWiseGraph = this.listOfEmpForQuestionWise[0].id;
  //       this.getQuestionWiseStatusGraph();
  //     } else {
  //       this.selectedEmployeeQuestionWiseGraph = null;
  //     }
  //   })
  // }

  getEmpNamesBy360IdQuestionWiseGraph() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }

    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewQuestionWiseID + '/' + isEmployee).subscribe((data: any) => {
      this.listOfEmpForQuestionWise = [];
      let tempList: any[] = [];

      // Build basic employee list
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        };
        tempList.push(obj);
      });

      // Filter based on band, department, AND selected competency
      if (this.competencylistForQuestionWiseGraph?.length && this.userData?.length && this.selectedCompetencyQuestionWise) {
        // Find selected competency object
        const selectedCompetency = this.competencylistForQuestionWiseGraph.find((c: { id: any }) => c.id == this.selectedCompetencyQuestionWise);
        if (selectedCompetency) {
          tempList = tempList.filter(emp => {
            const fullUser = this.userData.find(u => u.id == emp.id);
            if (!fullUser) return false;
            return selectedCompetency.band?.trim().toLowerCase() === fullUser.band?.trim().toLowerCase() && selectedCompetency.department?.trim().toLowerCase() === fullUser.department?.trim().toLowerCase();
          });
        }
      }

      //  only id & name for dropdown
      this.listOfEmpForQuestionWise = tempList.map(e => ({
        id: e.id,
        name: e.name
      }));

      if (this.listOfEmpForQuestionWise.length != 0) {
        this.selectedEmployeeQuestionWiseGraph = this.listOfEmpForQuestionWise[0].id;
        this.getQuestionWiseStatusGraph();
      } else {
        this.selectedEmployeeQuestionWiseGraph = null;
      }
    });
  }

  // User Details
  userData: any[] = [];

  getEmployeeDetiailsBandLocation() {
    this.httpService.callGetService(`${this.config.EmployeeDetiailsBandLocation}/${this.loggedInUserCompanyID}`).subscribe((result: any) => {
      this.userData = result.data || [];
      this.cdRef.detectChanges();
    });
  }

  // for dashboard dropdown

  selectedYearForCompetency: any = null;
  selectedSizeOfPMS: any = 25;

  getAllCompetencyList(searchString: string) {
    this.httpService.callGetService(this.config.getAllCompetencyList + this.loggedInUserCompanyID + '/' + searchString + '/' + this.selectedYearForCompetency + '?page=' + this.page + '&size=' + this.selectedSizeOfPMS).subscribe((response: any) => {
      // Handle API response here
    });
  }

  getQuestionWiseStatusGraph() {
    this.questionWiseGraphData = [];
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      this.selectedEmployeeQuestionWiseGraph = this.loggedInUserId;
    }
    const year = this.selectedYearQuestionWise?.split('-');
    const request = {
      band: null,
      companyId: this.loggedInUserCompanyID,
      competencyId: [this.selectedCompetencyQuestionWise],
      fromYear: year[0],
      isComplete: true,
      isTopAnalysis: true,
      reviewId: this.selectedReviewQuestionWiseID,
      toYear: year[1],
      userId: this.selectedEmployeeQuestionWiseGraph
    };
    this.httpService.callPostService(this.config.getQuestionWiseGraph, request).subscribe((data: any) => {
      this.questionWiseGraphData = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          value: ele.score,
          name: ele.parameterName
        };
        this.questionWiseGraphData.push(obj);
      });
      this.switchQuestionWiseGraphType('bar');
      // this.getSpiderWebGraph();
    });
  }

  switchQuestionWiseGraphType(graphType: string) {
    this.questionWiseIcon = graphType;
    this.questionWiseTable = false;
    const dom = document.getElementById('questionWiseGraph') as HTMLDivElement;
    setTimeout(() => {
      if (!dom) {
        console.warn('questionWiseGraph container not found yet.');
        return;
      }
      const chartEmpTaskStatus = echarts.init(dom);
      chartEmpTaskStatus.clear();
      if (graphType === 'bar') {
        this.questionWiseBarGraph(chartEmpTaskStatus);
      }
      if (graphType === 'line') {
        this.questionWiseLineGraph(chartEmpTaskStatus);
      }
      this.mobileResponsiveService.chartResizeFn(chartEmpTaskStatus);
    }, 800);
  }

  questionWiseBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center'
      },
      xAxis: [
        {
          type: 'category',
          data: this.questionWiseGraphData.map((ele: any) => ele.name),
          name: 'Question',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {}
      },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: this.questionWiseGraphData.map((ele: any) => ele.value),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          }
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  questionWiseLineGraph(chartEmpTaskStatus: any) {
    const options = {
      xAxis: [
        {
          type: 'category',
          data: this.questionWiseGraphData.map((ele: any) => ele.name),
          name: 'Question',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false }
      },
      tooltip: {
        trigger: 'axis'
      },
      series: [
        {
          name: 'Actual',
          type: 'line',
          data: this.questionWiseGraphData.map((ele: any) => ele.value)
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchQuestionWiseTable() {
    this.questionWiseIcon = '';
    this.questionWiseTable = true;
  }

  // Stakeholder Wise Graph
  reviewNamesActiveAndCompletedSatkeholderWise() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }

    this.listofReviewNamesActiveAndCompletedSatkeholderWise = [];
    this.listOfEmpForStakeholderWise = [];
    this.stakeholderWiseGraphData = [];

    this.selectedReviewSatkeholderWiseID = null;
    this.selectedEmployeeStakeholderWise = null;

    const test = this.selectedYearStakeholderWise?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + isEmployee).subscribe((data: any) => {
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        };
        this.listofReviewNamesActiveAndCompletedSatkeholderWise.push(obj);
        this.getStakeholderWiseGraph();
      });
      if (this.listofReviewNamesActiveAndCompletedSatkeholderWise.length != 0) {
        this.selectedReviewSatkeholderWiseID = this.listofReviewNamesActiveAndCompletedSatkeholderWise[0].id;
        this.getEmpNamesBy360IdStakeholderWiseGraph();
      } else {
        this.selectedReviewSatkeholderWiseID = null;
        this.getEmpNamesBy360IdStakeholderWiseGraph();
      }
    });

    // this.getStakeholderWiseGraph();
  }

  getEmpNamesBy360IdStakeholderWiseGraph() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewQuestionWiseID + '/' + isEmployee).subscribe((data: any) => {
      this.listOfEmpForStakeholderWise = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        };
        this.listOfEmpForStakeholderWise.push(obj);
      });
      if (this.listOfEmpForStakeholderWise.length != 0) {
        this.selectedEmployeeStakeholderWise = this.listOfEmpForStakeholderWise[0].id;
        this.getStakeholderWiseGraph();
      } else {
        this.selectedEmployeeStakeholderWise = null;
      }
    });
  }

  getStakeholderWiseGraph() {
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      this.selectedEmployeeStakeholderWise = this.loggedInUserId;
    }
    const year = this.selectedYearStakeholderWise?.split('-');
    const request = {
      band: null,
      companyId: this.loggedInUserCompanyID,
      competencyId: [],
      fromYear: year[0],
      isComplete: true,
      isTopAnalysis: true,
      reviewId: this.selectedReviewSatkeholderWiseID,
      toYear: year[1],
      userId: this.selectedEmployeeStakeholderWise
    };
    if (!request.reviewId) {
      // Set graph data to empty and render chart
      this.stakeholderWiseGraphData = [];
      this.switchStakeholderWiseGraphType('bar');
    } else {
      this.httpService.callPostService(this.config.getStakeholderWiseGraph, request).subscribe({
        next: (data: any) => {
          this.stakeholderWiseGraphData = [];

          if (data?.status) {
            const dataArray = data?.data || [];

            if (Array.isArray(dataArray) && dataArray.length > 0) {
              dataArray.forEach((ele: any) => {
                const obj = {
                  value: ele.score,
                  name: ele.parameterName
                };
                this.stakeholderWiseGraphData.push(obj);
              });
            }

            this.switchStakeholderWiseGraphType('bar');
          } else {
            console.warn('Response status is false:', data.message);
            this.stakeholderWiseGraphData = [];
            this.switchStakeholderWiseGraphType('bar');
          }
        },

        error: errorResponse => {
          console.error('HTTP Error:', errorResponse);

          // Optional: Show toast or message to user
          // this.toastService.error('Something went wrong');

          // In case of HTTP 500, send null or empty to graph handler
          this.stakeholderWiseGraphData = [];
          this.switchStakeholderWiseGraphType('bar');
        }
      });
    }
  }

  switchStakeholderWiseGraphType(graphType: string) {
    this.stakeholderWiseIcon = graphType;
    this.stakeholderWiseTable = false;
    const dom = document.getElementById('stakeholderWiseGraph') as HTMLDivElement;
    setTimeout(() => {
      if (!dom) {
        console.warn('stakeholderWiseGraph container not found yet.');
        return;
      }
      const chartEmpTaskStatus = echarts.init(dom);
      chartEmpTaskStatus.clear();
      if (graphType === 'bar') {
        this.stakeholderWiseBarGraph(chartEmpTaskStatus);
      }
      if (graphType === 'line') {
        this.stakeholderWiseLineGraph(chartEmpTaskStatus);
      }
      this.mobileResponsiveService.chartResizeFn(chartEmpTaskStatus);
    }, 800);
  }

  stakeholderWiseBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['Score'],
        bottom: 0,
        left: 'center'
      },
      xAxis: [
        {
          type: 'category',
          data: this.stakeholderWiseGraphData.map((ele: any) => ele.name),
          name: 'Dimension',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {}
      },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: this.stakeholderWiseGraphData.map((ele: any) => ele.value),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          }
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  stakeholderWiseLineGraph(chartEmpTaskStatus: any) {
    const options = {
      xAxis: [
        {
          type: 'category',
          data: this.stakeholderWiseGraphData.map((ele: any) => ele.name),
          name: 'Dimension',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false }
      },
      tooltip: {
        trigger: 'axis'
      },
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: this.stakeholderWiseGraphData.map((ele: any) => ele.value)
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchStakeholderWiseTable() {
    this.stakeholderWiseIcon = '';
    this.stakeholderWiseTable = true;
  }

  switchDemographicTrendAnalysisTable() {
    this.demographicTrendAnalysisIcon = '';
    this.demographicTrendAnalysisTableIcon = true;
  }

  // ------------------------How Did I Fare In The 360 Dashboard-------------------

  reviewNamesActiveAndCompletedHowDidIFareWise() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }

    this.listofReviewNamesActiveAndCompletedHowDidIFareWise = [];
    this.selectedReviewHowDidFareWiseID = null;

    const test = this.selectedYearHowDidFareWise?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + isEmployee).subscribe((data: any) => {
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        };
        this.listofReviewNamesActiveAndCompletedHowDidIFareWise.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedHowDidIFareWise.length != 0) {
        this.selectedReviewHowDidFareWiseID = this.listofReviewNamesActiveAndCompletedHowDidIFareWise[0].id;
      } else {
        this.selectedReviewHowDidFareWiseID = null;
      }
      this.getHowDidIFareGraph();
    });
  }

  getHowDidIFareGraph() {
    const year = this.selectedYearHowDidFareWise?.split('-');
    let userId;
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
      userId = this.loggedInUserId;
    } else {
      userId = null;
    }
    const request = {
      band: null,
      companyId: this.loggedInUserCompanyID,
      competencyId: [],
      fromYear: year[0],
      isComplete: true,
      isTopAnalysis: true,
      reviewId: this.selectedReviewHowDidFareWiseID,
      toYear: year[1],
      userId: userId || null
    };
    if (!request.reviewId) {
      // Set graph data to empty and render chart
      this.howDidIFareWiseGraphData = [];
      this.switchHowDidIFareGraphType('bar');
    } else {
      this.httpService.callPostService(this.config.getHowDidIFareGraph, request).subscribe({
        next: (data: any) => {
          this.howDidIFareWiseGraphData = [];

          const dataArray = data?.data.filter((e: any) => e.score > 0) || [];

          if (Array.isArray(dataArray) && dataArray.length > 0) {
            dataArray.forEach((ele: any) => {
              const obj = {
                value: ele.score,
                name: ele.parameterName
              };
              this.howDidIFareWiseGraphData.push(obj);
            });
          } else {
            console.warn('No data returned for HowDidIFare graph.');
          }

          this.switchHowDidIFareGraphType('bar');
        },

        error: errorResponse => {
          console.error('Error fetching HowDidIFare graph data:', errorResponse);

          // Set empty data on error and attempt to render chart safely
          this.howDidIFareWiseGraphData = [];
          this.switchHowDidIFareGraphType('bar');
        }
      });
    }
  }

  switchHowDidIFareGraphType(graphType: string) {
    this.HowDidIFareIcon = graphType;
    this.HowDidIFareTable = false;
    const dom = document.getElementById('HowDidIFareDashboardGraph') as HTMLDivElement;
    setTimeout(() => {
      if (!dom) {
        console.warn('HowDidIFareDashboardGraph container not found yet.');
        return;
      }
      const chartEmpTaskStatus = echarts.init(dom);
      chartEmpTaskStatus.clear();
      if (graphType === 'bar') {
        this.HowDidIFareBarGraph(chartEmpTaskStatus);
      }
      if (graphType === 'pie') {
        this.HowDidIFarePieGraph(chartEmpTaskStatus);
      }
      if (graphType === 'line') {
        this.HowDidIFareLineGraph(chartEmpTaskStatus);
      }
      this.mobileResponsiveService.chartResizeFn(chartEmpTaskStatus);
    }, 800);
  }

  HowDidIFareBarGraph(chartEmpTaskStatus: any) {
    console.log(this.howDidIFareWiseGraphData + '..........................');
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['Score'],
        bottom: 0,
        left: 'center'
      },
      xAxis: [
        {
          type: 'category',
          data: this.howDidIFareWiseGraphData.filter((ele: any) => ele.value > 0).map((ele: any) => ele.name),
          name: 'Dimension',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {}
      },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: this.howDidIFareWiseGraphData.filter((ele: any) => ele.value > 0).map((ele: any) => ele.value),

          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          }
        }
      ]
    };

    chartEmpTaskStatus.setOption(options);
  }

  HowDidIFarePieGraph(chartEmpTaskStatus: any) {
    const pieChartData = this.howDidIFareWiseGraphData
      .filter((ele: any) => ele.value > 0) // keep only value > 0
      .map((ele: any) => ({
        value: ele.value,
        name: ele.name
      }));

    const options = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          // name: 'Employee Count by Rating',
          type: 'pie',
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: pieChartData
        }
      ]
    };

    chartEmpTaskStatus.setOption(options);
  }

  HowDidIFareLineGraph(chartEmpTaskStatus: any) {
    const options = {
      xAxis: [
        {
          type: 'category',
          data: this.howDidIFareWiseGraphData.filter((ele: any) => ele.value > 0).map((ele: any) => ele.name),

          name: 'Dimension',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false }
      },
      tooltip: {
        trigger: 'axis'
      },
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: this.howDidIFareWiseGraphData.filter((ele: any) => ele.value > 0).map((ele: any) => ele.value)
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchHowDidIFareTable() {
    this.HowDidIFareIcon = '';
    this.HowDidIFareTable = true;
  }

  // ------------------------ Top 2 vs Bottom 2 Analysis -------------------

  reviewNamesActiveAndCompletedTopandBottomWise() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }

    this.listofReviewNamesActiveAndCompletedTopandBottomWise = [];
    this.listOfEmpForTopandBottomWise = [];

    this.selectedReviewTopandBottomId = null;
    this.selectedEmployeeForTopandBottom = null;

    const test = this.selectedYearTopandBottom?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + isEmployee).subscribe((data: any) => {
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        };
        this.listofReviewNamesActiveAndCompletedTopandBottomWise.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedTopandBottomWise.length != 0) {
        this.selectedReviewTopandBottomId = this.listofReviewNamesActiveAndCompletedTopandBottomWise[0].id;
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
          this.getEmpNamesBy360IdTopandBottomWiseGraph();
        }
      } else {
        this.selectedReviewTopandBottomId = null;
      }
      this.getTopVsBottomAnalysisGraph();
    });
  }

  getEmpNamesBy360IdTopandBottomWiseGraph() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewTopandBottomId + '/' + isEmployee).subscribe((data: any) => {
      this.listOfEmpForTopandBottomWise = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        };
        this.listOfEmpForTopandBottomWise.push(obj);
      });
      if (this.listOfEmpForTopandBottomWise.length != 0) {
        this.selectedEmployeeForTopandBottom = this.listOfEmpForTopandBottomWise[0].id;
        this.getTopVsBottomAnalysisGraph();
      } else {
        this.selectedEmployeeForTopandBottom = null;
      }
    });
  }

  onTopandBottomChange(event: any) {
    this.getTopVsBottomAnalysisGraph();
  }

  getTopVsBottomAnalysisGraph() {
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      this.selectedEmployeeForTopandBottom = this.loggedInUserId;
    }
    const year = this.selectedYearTopandBottom?.split('-');
    const request = {
      band: null,
      companyId: this.loggedInUserCompanyID,
      competencyId: [],
      fromYear: year[0],
      isComplete: true,
      isTopAnalysis: this.istopandbottomAnalysis,
      reviewId: this.selectedReviewTopandBottomId,
      toYear: year[1],
      userId: this.selectedEmployeeForTopandBottom
    };
    console.log('Role:', this.loggedInUserRole, 'Request:', request);

    // 🔁 Check if reviewId is null/undefined
    if (!request.reviewId) {
      // Set graph data to empty and render chart
      this.topandBottomGraphData = [];
      this.switchtopandBottomWiseGraphType('bar');
    } else {
      // Make the API call only if reviewId exists
      this.httpService.callPostService(this.config.getTopVsBottomAnalysisGraph, request).subscribe({
        next: (data: any) => {
          const dataArray = data?.data || [];

          if (Array.isArray(dataArray) && dataArray.length > 0) {
            this.topandBottomGraphData = dataArray;
          } else {
            this.topandBottomGraphData = [];
          }

          this.switchtopandBottomWiseGraphType('bar');
        },

        error: errorResponse => {
          console.error('Error fetching Top vs Bottom Analysis graph:', errorResponse);
          this.topandBottomGraphData = [];
          this.switchtopandBottomWiseGraphType('bar');
        }
      });
    }
  }

  switchtopandBottomWiseGraphType(graphType: string) {
    this.stakeholderWiseIcon = graphType;
    this.stakeholderWiseTable = false;
    const dom = document.getElementById('topToBottomAnalysisGraph') as HTMLDivElement;
    if (!dom) {
      console.warn('topToBottomAnalysisGraph container not found yet.');
      return;
    }
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.topandBottomWiseBarGraph(chartEmpTaskStatus);
    }
    // if (graphType === 'line') {
    //   this.topandBottomWiseBarGraph(chartEmpTaskStatus);
    // }
    this.mobileResponsiveService.chartResizeFn(chartEmpTaskStatus);
  }

  topandBottomWiseBarGraph(chartEmpTaskStatus: any): void {
    const stakeholders: string[] = this.topandBottomGraphData.map((ele: any) => ele.stakeholderType);

    const questionNames: string[] = Array.from(new Set(this.topandBottomGraphData.flatMap((ele: any) => ele.questions.map((q: any) => q.question))));

    // Dynamically truncate based on screen width
    const maxWords = window.innerWidth < 768 ? 2 : 5;
    const truncatedQuestionNames: string[] = questionNames.map((question: string) => {
      const words = question.split(' ');
      return words.length > maxWords ? words.slice(0, maxWords).join(' ') + '...' : question;
    });

    const colorPalette: string[] = ['#6A4C93', '#F3820E', '#4CAF50', '#FF5733'];

    const seriesData = questionNames.map((question: string, index: number) => ({
      name: truncatedQuestionNames[index],
      type: 'bar',
      barGap: '40%',
      data: this.topandBottomGraphData.map((stakeholder: any) => {
        const found = stakeholder.questions.find((q: any) => q.question === question);
        return found ? found.score : 0;
      }),
      label: {
        show: true,
        position: 'insideLeft',
        fontSize: 12,
        color: '#fff',
        formatter: (params: any) => (params.value > 0 ? `${params.seriesName} : ${params.value}` : '')
      },
      itemStyle: {
        color: colorPalette[index % colorPalette.length]
      }
    }));

    const options = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params: any) => {
          let tooltipContent = '';
          params.forEach((item: any) => {
            const fullQuestionName = questionNames[truncatedQuestionNames.indexOf(item.seriesName)];
            if (item.value > 0) {
              tooltipContent += `
                <div style="
                  max-width: ${window.innerWidth < 768 ? '200px' : '600px'}; 
                  white-space: normal; 
                  word-wrap: break-word;
                  color: ${item.color}; 
                  font-weight: bold;
                ">
                  ${fullQuestionName}: ${item.value}
                </div>`;
            }
          });
          return tooltipContent || '';
        }
      },
      legend: {
        data: truncatedQuestionNames,
        bottom: 0,
        left: 'center',
        tooltip: {
          show: true,
          formatter: (param: any) => questionNames[truncatedQuestionNames.indexOf(param.name)]
        },
        formatter: (name: string) => truncatedQuestionNames[truncatedQuestionNames.indexOf(name)]
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '18%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'value',
          name: 'Score',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 18
          }
        }
      ],
      yAxis: {
        type: 'category',
        data: stakeholders,
        name: 'Stakeholders',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        axisLabel: {
          interval: 0,
          width: 100,
          overflow: 'truncate',
          formatter: (value: string) => {
            return window.innerWidth < 768 ? (value.length > 15 ? value.slice(0, 15) + '...' : value) : value;
          }
        }
      },
      series: seriesData
    };

    chartEmpTaskStatus.setOption(options);
  }

  // ------------------------ Spider Web -------------------

  reviewNamesActiveAndCompletedSpiderGraph() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }

    this.listofReviewNamesActiveAndCompletedSpiderGraph = [];
    this.listOfEmpForSpiderGraph = [];

    this.selectedReviewSpidergraphId = null;
    this.selectedEmployeeForSpiderGraph = null;

    const test = this.selectedYearSpiderWeb?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + isEmployee).subscribe((data: any) => {
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        };
        this.listofReviewNamesActiveAndCompletedSpiderGraph.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedSpiderGraph.length != 0) {
        this.selectedReviewSpidergraphId = this.listofReviewNamesActiveAndCompletedSpiderGraph[0].id;

        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
          this.getEmpNamesBy360IdSpiderGraph();
        }
      } else {
        this.selectedReviewSpidergraphId = null;
      }
      this.getSpiderWebGraph();
    });
  }

  getEmpNamesBy360IdSpiderGraph() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewSpidergraphId + '/' + isEmployee).subscribe((data: any) => {
      this.listOfEmpForSpiderGraph = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        };
        this.listOfEmpForSpiderGraph.push(obj);
      });
      if (this.listOfEmpForSpiderGraph.length != 0) {
        this.selectedEmployeeForSpiderGraph = this.listOfEmpForSpiderGraph[0].id;
        this.getSpiderWebGraph();
      } else {
        this.selectedEmployeeForSpiderGraph = null;
      }
    });
  }

  getSpiderWebGraph() {
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      this.selectedEmployeeForSpiderGraph = this.loggedInUserId;
    }
    const year = this.selectedYearSpiderWeb?.split('-');
    const request = {
      band: null,
      companyId: this.loggedInUserCompanyID,
      competencyId: [],
      fromYear: year[0],
      isComplete: true,
      isTopAnalysis: true,
      reviewId: this.selectedReviewSpidergraphId,
      toYear: year[1],
      userId: this.selectedEmployeeForSpiderGraph
    };
    this.httpService.callPostService(this.config.getSpiderWebGraph, request).subscribe((data: any) => {
      this.spiderGraphData = data?.data;
      this.switchspiderWebGraphType('bar');
    });
  }
  switchspiderWebGraphType(graphType: string) {
    this.stakeholderWiseIcon = graphType;
    this.stakeholderWiseTable = false;
    const dom = document.getElementById('spiderWebGraph') as HTMLDivElement;
    setTimeout(() => {
      if (!dom) {
        console.warn('spiderWebGraph container not found yet.');
        return;
      }
      const chartEmpTaskStatus = echarts.init(dom);
      chartEmpTaskStatus.clear();
      // if (graphType === 'bar') {
      this.spiderWebGraph(chartEmpTaskStatus);
      // }
      this.mobileResponsiveService.chartResizeFn(chartEmpTaskStatus);
    }, 800);
  }
  getMaxScore() {
    return this.spiderGraphData.reduce((max: any, obj: any) => {
      const scores = Object.values(obj.scoreDetails).filter(score => score !== null) as number[];
      const maxScore = scores.length ? Math.max(...scores) : null;
      return maxScore !== null ? Math.max(max, maxScore) : max;
    }, null);
  }

  spiderWebGraph(chartEmpTaskStatus: any) {
    let indicators = this.spiderGraphData.map((item: any) => ({
      name: item.competencyName,
      max: this.getMaxScore()
    }));
    const roles = ['self', 'peer', 'subordinate', 'superior', 'internalCustomer', 'externalCustomer'];
    let seriesData = roles
      .map(role => ({
        name: role.charAt(0).toUpperCase() + role.slice(1),
        value: this.spiderGraphData.map((item: any) => item.scoreDetails[role] ?? 0)
      }))
      .filter(data => data.value.some((val: any) => val > 0));

    console.warn('seriesData', seriesData);
    console.warn('indicators', indicators);

    var option = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: seriesData.map(item => item.name),
        left: 'center'
      },
      radar: {
        center: ['50%', '55%'], // 👈 always keep radar centered
        radius: '65%',
        indicator: indicators,
        shape: 'polygon',
        splitNumber: 5,
        axisLine: { lineStyle: { color: 'gray' } },
        splitLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.1)' } },
        splitArea: { areaStyle: { color: 'rgba(0, 0, 0, 0.05)' } }
      },
      series: [
        {
          name: '360 Review Scores',
          type: 'radar',
          data: seriesData
        }
      ]
    };

    chartEmpTaskStatus.setOption(option);
  }

  // -----------------------------------360 Review Master-----------------------------------

  surveyPopup() {
    const successdialogRef = this.dialog.open(ThreeSixtyReviewPopupComponent, {
      disableClose: true,
      height: '30%',
      width: this.mobileResponsiveService.modelWidthForMobileDevice,
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {}
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  // -----------------------------------------My Master---------------------------------------
  toggleInfoPopup() {
    this.showInfoPopup = !this.showInfoPopup;
  }
  // -----------------------------------------Reports-----------------------------------------

  showScoreCardReport(buttonName: any) {
    this.selectedSubTab = buttonName;
    if (this.selectedSubTab == 'Dump Report') {
      this.isDisabledDatePicker = true;
    } else {
      this.isDisabledDatePicker = true;
    }
    this.onChangeReviewNameOfReport();
  }

  onSelectEmployee() {
    this.getAtoZReport();
  }

  onDeSelectEmployee() {
    if (this.selectedSubTab == 'A-Z report' && this.selectedEmployeeForReport != 0) {
      this.AtoZReportListData = [];
    }
  }

  selectAllEmployee(data: any) {
    this.selectedEmployeeForReport = data;
    this.onChangeReviewNameOfReport();
  }
  onDeSelectAllEmployee() {
    if (this.selectedSubTab == 'A-Z report') {
      this.AtoZReportListData = [];
    } else {
      this.selectedEmployeeForReport = [];
    }
  }
  currentFiscalYear: any;

  getYearsOfCompany() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.yearsOfCompany = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        };
        if (test[0] != null && test[1] != null) {
          this.yearsOfCompany.push(obj);
        }
      });
      this.yearsOfCompany?.forEach((ele: any) => {
        const currentYear = new Date().getFullYear();
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        let yearValue = '';
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
            if (currentMonth < 3) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if (this.loggedInCompanyFiscalyear === 'July_Jun') {
            if (currentMonth < 6) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
            if (currentMonth < 9) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
        }
        this.currentFiscalYear = yearValue;
        if (ele?.year == yearValue) {
          this.selectedYear = ele?.year;
          this.selectedYearCompetencyWise = ele?.year;
          this.selectedYearQuestionWise = ele?.year;
          this.selectedYearStakeholderWise = ele?.year;
          this.selectedYearHowDidFareWise = ele?.year;
          this.selectedYearTopandBottom = ele?.year;
          this.selectedYearSpiderWeb = ele?.year;
          if (this.selectedTypeTabName == 'Participate in 360 Review') {
            this.reviewNamesOfUser();
          } else if (this.selectedTypeTabName == 'Dashboard') {
            this.reviewNamesActiveAndCompleted();
          } else {
            this.getListOfReviewName();
          }
        }
      });
      if (this.showSetupPopup) {
      } else {
        this.getAll360();
      }
    });
  }
  listofReviewNames: any = [];
  selectedReviewID: any;
  showDataSection: boolean = false;

  getListOfReviewName() {
    const test = this.selectedYear?.split('-');
    this.httpService.callGetService(this.config.reviewName + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.listofReviewNames = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        };
        this.listofReviewNames.push(obj);
      });
      const isCurrentYear = this.selectedYear === this.getCurrentFiscalYear();

      // Control UI visibility
      this.showDataSection = isCurrentYear || this.listofReviewNames.length > 0;

      if (this.listofReviewNames.length != 0) {
        this.selectedReviewID = this.selectedReviewID ? this.selectedReviewID : this.listofReviewNames[0].id;

        // this.getReview360ByIdAndUser();
      } else {
        this.selectedReviewID = null;
      }
      this.getReviewByID();
    });
  }

  // Add this helper
  getCurrentFiscalYear(): string {
    const today = new Date();
    let startYear = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
    let endYear = startYear + 1;
    return `${startYear}-${endYear}`;
  }
  listofReviewNamesActiveAndCompleted: any = [];
  reviewName: any;
  reviewNamesActiveAndCompleted() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }
    const test = this.selectedYear?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + isEmployee).subscribe((data: any) => {
      this.listofReviewNamesActiveAndCompleted = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        };
        this.listofReviewNamesActiveAndCompleted.push(obj);
      });
      this.listofReviewNamesActiveAndCompletedCompetencyWise = this.listofReviewNamesActiveAndCompleted;
      this.listofReviewNamesActiveAndCompletedQuestionWise = this.listofReviewNamesActiveAndCompleted;
      this.listofReviewNamesActiveAndCompletedSatkeholderWise = this.listofReviewNamesActiveAndCompleted;
      this.listofReviewNamesActiveAndCompletedHowDidIFareWise = this.listofReviewNamesActiveAndCompleted;
      this.listofReviewNamesActiveAndCompletedTopandBottomWise = this.listofReviewNamesActiveAndCompleted;
      this.listofReviewNamesActiveAndCompletedSpiderGraph = this.listofReviewNamesActiveAndCompleted;
      if (this.listofReviewNamesActiveAndCompleted.length != 0) {
        this.selectedReviewID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewGlobalDashboardID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewCompetencyWiseID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewQuestionWiseID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewSatkeholderWiseID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewHowDidFareWiseID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewTopandBottomId = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewSpidergraphId = this.listofReviewNamesActiveAndCompleted[0].id;

        let reviewNamefied = this.listofReviewNamesActiveAndCompleted.filter((e: any) => e.id == this.selectedReviewGlobalDashboardID);

        this.reviewName = reviewNamefied[0]?.name;
        if (this.selectedTypeTabName == 'Dashboard') {
          this.get360Counter();
          //  this.getReviewByID();
          this.getBandNamesReviewId();
          this.getCompetencyNamesBy360Id();
          this.getHowDidIFareGraph();
        }
        if (this.selectedTypeTabName == 'Reports') {
          this.getEmpNameForReport();
        } else {
          this.getEmpNamesBy360Id();
        }
        this.getReviewByID();
        // this.getReview360ByIdAndUser();
      } else {
        this.selectedReviewID = null;
        this.selectedReviewGlobalDashboardID = null;
        this.selectedReviewCompetencyWiseID = null;
        this.selectedReviewQuestionWiseID = null;
        this.selectedReviewSatkeholderWiseID = null;
        this.selectedReviewHowDidFareWiseID = null;
        this.selectedReviewTopandBottomId = null;
        this.selectedReviewSpidergraphId = null;
      }
    });
  }
  participatein360ReviewArrayList: any = [];
  ratingBasedList: any = [];
  selectedReviewGlobalDashboardID: any;
  // getReviewByIdForDashboard() {
  //   this.httpService.callGetService(this.config.getessByID + this.selectedReviewGlobalDashboardID).subscribe((data: any) => {
  //     this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;
  //     console.log("is show dahsboard to hr...",  this.isShowDashboardToHR);

  //     this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
  //        console.log("is show dahsboard to hr...",  this.isShowDashboardToHR);
  //   })
  // }

  // getReviewByIdForReport() {
  //   this.httpService.callGetService(this.config.getessByID + this.selectedReviewID).subscribe((data: any) => {
  //     this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;
  //     this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
  //     if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
  //       this.onChangeReviewNameOfReport();
  //     }
  //   })
  // }

  isCheckSave: any = true;
  reviewExpired: any;
  getReviewByID() {
    this.stakeHoldersArrayForSetup = [
      { name: 'Self', selected: false, weightage: 0 },
      { name: 'Superior', selected: false, weightage: 0 },
      { name: 'Peer', selected: false, weightage: 0 },
      { name: 'Subordinate', selected: false, weightage: 0 },
      { name: 'Internal Customer', selected: false, weightage: 0 },
      { name: 'External Customer', selected: false, weightage: 0 } // optional if needed
    ];

    const request = {
      id: this.selectedReviewID,
      search: null
    };
    this.intructionList = [];
    this.httpService.callPostService(this.config.getReview360ById, request).subscribe((data: any) => {
      this.selectedReviewName = data?.data?.reviewName;
      this.selectedReviewStartDate = data?.data?.startDate;
      this.selectedReviewEndDate = data?.data?.endDate;
      this.selectedReviewStatus = data?.data?.reviewStatus;
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;
      this.isExternalCustomerEnabled = data?.data?.isExternalCustomerEnabled;
      this.onSeletReminderOption = data?.data?.isReminderOn;
      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
      this.selectedDatesForReminder = data?.data?.reminderDate;

      console.log(data?.data);

      const weightages = {
        selfWeightage: data?.data?.selfWeightage,
        superiorWeightage: data?.data?.superiorWeightage,
        subordinateWeightage: data?.data?.subordinateWeightage,
        peerWeightage: data?.data?.peerWeightage,
        internalCustomerWeightage: data?.data?.internalCustomerWeightage,
        externalCustomerWeightage: data?.data?.externalCustomerWeightage
      };
      console.log(weightages);

      this.stakeHoldersArrayForSetup = [
        { name: 'Self', selected: weightages.selfWeightage != null, weightage: weightages.selfWeightage },
        { name: 'Superior', selected: weightages.superiorWeightage != null, weightage: weightages.superiorWeightage },
        { name: 'Peer', selected: weightages.peerWeightage != null, weightage: weightages.peerWeightage },
        { name: 'Subordinate', selected: weightages.subordinateWeightage != null, weightage: weightages.subordinateWeightage },
        { name: 'Internal Customer', selected: weightages.internalCustomerWeightage != null, weightage: weightages.internalCustomerWeightage },
        { name: 'External Customer', selected: weightages.externalCustomerWeightage != null, weightage: weightages.externalCustomerWeightage }
      ];

      console.log(this.stakeHoldersArrayForSetup);

      if (data.data?.id != null && data.data?.isSave != null) {
        this.isCheckSave = false;
      } else {
        this.isCheckSave = true;
      }
      console.warn(data.data?.isSave);

      if (data?.data?.reminderDate?.length != 0) {
        this.latestSelectedDate = data?.data?.reminderDate[0];
      }
      if (this.isExternalCustomerEnabled == true) {
        // this.stakeHoldersArrayForSetup.push({ name: 'External Customer' });
      }

      if (this.selectedReviewEndDate) {
        const today = new Date();
        const endDate = new Date(this.selectedReviewEndDate);

        // Strip time from both dates
        today.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        this.reviewExpired = today > endDate;
      }

      this.selectedLocationForSetup = [];
      data?.data?.location.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.selectedLocationForSetup.push(obj);
      });
      this.selectedBandForSetup = [];
      data?.data?.band.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.selectedBandForSetup.push(obj);
      });
      this.selectedGradeForSetup = [];
      data?.data?.grade.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.selectedGradeForSetup.push(obj);
      });
      this.selectedFunctionForSetup = [];
      data?.data?.department.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.selectedFunctionForSetup.push(obj);
      });
      this.selectedEmployeeId = [];
      data?.data?.employee?.forEach((ele: any) => {
        let obj = {
          id: ele
        };
        this.selectedEmployeeId.push(obj);
      });
      this.selectedTemplateColorName = data?.data?.templateName ? data?.data?.templateName : 'Red';
      this.reviewDateOfJoining = data?.data?.reviewCutoff;
      this.templateColorList.forEach((ele: any) => {
        if (ele.colorName == data?.data?.templateName) {
          this.selectedTemplateColorCode = ele.stripcolor;
          this.selectedtemplateBgColor = ele.backgroundColor;
        }
      });

      if (data?.data?.instruction?.length != 0) {
        this.intructionList = data?.data?.instruction;
      }
      this.ratingBasedList = [];
      if (data?.data?.ratings?.length != 0) {
        this.ratingList = data?.data?.ratings;
        data?.data?.ratings?.forEach((ele: any) => {
          if (ele.questionType == 'Rating Based') {
            let obj = {
              id: ele.id,
              questionType: ele.questionType,
              rating: ele.rating,
              ratingDefinition: ele.ratingDefinition
            };
            this.ratingBasedList.push(obj);
          }
        });
      } else {
        this.ratingList = [
          {
            id: null,
            questionType: 'Rating Based',
            rating: null,
            ratingDefinition: ''
          }
        ];
      }
      this.invitationEmailBody = data?.data?.invitationEmailBody;
      this.invitationEmailSubject = data?.data?.invitationEmailSubject;
      this.submissionEmailBody = data?.data?.submissionEmailBody;
      this.submissionEmailSubject = data?.data?.submissionEmailSubject;
      this.externalCustomerWeightage = data?.data?.externalCustomerWeightage;
      this.subordinateWeightage = data?.data?.subordinateWeightage;
      this.superiorWeightage = data?.data?.superiorWeightage;
      this.selfWeightage = data?.data?.selfWeightage;
      this.peerWeightage = data?.data?.peerWeightage;
      this.internalCustomerWeightage = data?.data?.internalCustomerWeightage;
      this.stakeholdersArray = data?.data?.stakeholders;
      this.getCompetencyList = data?.data?.competencies;
      this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
      this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
      if (this.showSetupPopup) {
        this.getLocationsListForEssSetup();
        if (this.selectedLocationForSetup.length != 0) {
          this.getBandsListForEssSetup();
          this.getGradesListForEssSetup();
          this.getDeptListForEssSetup();
          this.getEmpListForEssSetup();
        }
      }

      if (this.selectedTypeTabName == 'Participate in 360 Review') {
        this.getEmployeeNamesByReviewIDUserId();
      }
    });
  }
  isEditActive: boolean = false;
  selectedReviewName: any = null;
  selectedReviewStartDate: any = null;
  selectedReviewEndDate: any = null;
  selectedReviewStatus: any;
  isShowDashboardToHR: any = false;
  stakeHoldersArrayForSetup: any = [
    { name: 'Self', selected: false },
    { name: 'Superior', selected: false },
    { name: 'Peer', selected: false },
    { name: 'Subordinate', selected: false },
    { name: 'Internal Customer', selected: false }
  ];
  isExternalCustomerEnabled: boolean = false;
  ratingList = [
    {
      id: null,
      questionType: 'Rating Based',
      rating: null,
      ratingDefinition: ''
    }
  ];
  intructionList: any = [];
  invitationEmailBody: any;
  invitationEmailSubject: any;
  submissionEmailBody: any;
  submissionEmailSubject: any;
  editSurvey() {
    this.isEditActive = true;
  }
  closeSurveyEdit() {
    this.isEditActive = false;
  }
  isRatingDuplicate: boolean = false;
  updateReview() {
    const test = this.selectedYear?.split('-');
    let externalCheck = this.stakeHoldersArrayForSetup.filter((s: { name: string; selected: boolean }) => s.name === 'External Customer' && s.selected === true);

    if (externalCheck) {
      this.isExternalCustomerEnabled = true;
    }

    var flag = true;
    if (!this.isEditActive) {
      if (this.selectedBandForSetup.length == 0) {
        flag = false;
      }
      if (this.selectedFunctionForSetup.length == 0) {
        flag = false;
      }
      if (this.selectedEmployeeId.length == 0) {
        flag = false;
      }
      if (this.selectedGradeForSetup.length == 0) {
        flag = false;
      }
      if (this.selectedLocationForSetup.length == 0) {
        flag = false;
      }
      // if (!this.externalCustomerWeightage) { flag = false };
      if (this.intructionList.length == 0) {
        flag = false;
      }

      if (!this.invitationEmailBody) {
        flag = false;
      }
      if (!this.invitationEmailSubject) {
        flag = false;
      }
      if (!this.reviewDateOfJoining) {
        flag = false;
      }
      if (!this.submissionEmailBody) {
        flag = false;
      }
      if (!this.submissionEmailSubject) {
        flag = false;
      }
      // if (!this.peerWeightage) { flag = false };
      // if (!this.selfWeightage) { flag = false };
      // if (!this.subordinateWeightage) { flag = false };
      // if (!this.superiorWeightage) { flag = false };
      // if (!this.internalCustomerWeightage) { flag = false };
      // Check stakeholder-dependent weightages dynamically
      // this.stakeHoldersArrayForSetup?.forEach((stakeholder: { selected: any; name: any; }) => {
      //   if (stakeholder.selected) {
      //     switch (stakeholder.name) {
      //       case 'Peer':
      //         if (!this.peerWeightage) flag = false;
      //         break;
      //       case 'Self':
      //         if (!this.selfWeightage) flag = false;
      //         break;
      //       case 'Subordinate':
      //         if (!this.subordinateWeightage) flag = false;
      //         break;
      //       case 'Superior':
      //         if (!this.superiorWeightage) flag = false;
      //         break;
      //       case 'Internal Customer':
      //         if (!this.internalCustomerWeightage) flag = false;
      //         break;
      //       default:
      //         break;
      //     }
      //   }
      // });

      if (this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based' && ele.rating == null)) {
        flag = false;
      }
      if (this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based' && ele.ratingDefinition == '')) {
        flag = false;
      }
      var tempRatings: any = [];
      this.isRatingDuplicate = false;
      for (let item of this.ratingList) {
        if (tempRatings.includes(item.rating)) {
          flag = false;
          this.isRatingDuplicate = true;
          break;
        }
        tempRatings.push(item.rating);
      }
      var arraygetCompetencyList: any = [];
      this.getCompetencyList.forEach((ele: any) => {
        ele.competencies.forEach((ele1: any) => {
          let obj = {
            band: ele.band,
            competencyName: ele1.competencyName,
            department: ele.department,
            id: ele1.competencyId || null,
            questions: ele1.questions
          };
          arraygetCompetencyList.push(obj);
        });
      });

      if (arraygetCompetencyList.some((item: any) => item.questions.some((q: any) => q.question === ''))) {
        flag = false;
      }
    }
    var reminderDates: any = [];
    if (this.onSeletReminderOption) {
      if (this.selectedDatesForReminder.length == 0) {
        flag = false;
      }
      this.selectedDatesForReminder?.forEach((ele: any) => {
        reminderDates.push(this.datePipe.transform(ele, 'yyyy-MM-dd'));
      });
    } else {
      reminderDates = [];
    }

    console.log(flag);

    if (flag == true) {
      const request = {
        band: this.selectedBandForSetup?.map((ele: { id: any }) => ele.id),
        companyId: this.loggedInUserCompanyID,
        competencies: arraygetCompetencyList,
        department: this.selectedFunctionForSetup?.map((ele: { id: any }) => ele.id),
        employee: this.selectedEmployeeId?.map((ele: { id: any }) => ele.id),
        endDate: this.datePipe.transform(this.selectedReviewEndDate, 'yyyy-MM-dd'),
        externalCustomerWeightage: this.externalCustomerWeightage,
        fromYear: test[0],
        grade: this.selectedGradeForSetup?.map((ele: { id: any }) => ele.id),
        id: this.selectedReviewID,
        instruction: this.intructionList,
        internalCustomerWeightage: this.internalCustomerWeightage,
        invitationEmailBody: this.invitationEmailBody,
        invitationEmailSubject: this.invitationEmailSubject,
        isExternalCustomerEnabled: this.isExternalCustomerEnabled,
        isReminderOn: this.onSeletReminderOption,
        isReportsVisibleToHr: this.isShowDashboardToHR,
        location: this.selectedLocationForSetup?.map((ele: { id: any }) => ele.id),
        peerWeightage: this.peerWeightage,
        ratings: this.ratingList,
        reminderDate: reminderDates,
        review360Name: this.selectedReviewName,
        review360Status: this.selectedReviewStatus,
        reviewCutoff: this.datePipe.transform(this.reviewDateOfJoining, 'yyyy-MM-dd'),
        selfWeightage: this.selfWeightage,
        stakeholders: this.stakeholdersArray,
        startDate: this.datePipe.transform(this.selectedReviewStartDate, 'yyyy-MM-dd'),
        submissionEmailBody: this.submissionEmailBody,
        submissionEmailSubject: this.submissionEmailSubject,
        subordinateWeightage: this.subordinateWeightage,
        superiorWeightage: this.superiorWeightage,
        templateName: this.selectedTemplateColorName,
        toYear: test[1],
        isSave: true
      };

      // this.loader.simpleLoader();
      this.httpService.callPostService(this.config.save360, request).subscribe(
        (data: any) => {
          this.loader.dismissLoader();
          this.isEditActive = false;
          if (data?.status) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getReviewByID();
              // this.getReview360ByIdAndUser();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getReviewByID();
              // this.getReview360ByIdAndUser();
            });
          }
        },
        error => {
          if (error) {
            this.loader.dismissLoader();
          }
        }
      );
    } else {
      if (this.isRatingDuplicate) {
        this.toastr.error('Rating is duplicate', '', {
          timeOut: 3000
        });
      }
      this.toastr.error('Please fill all mandetory fields.', '', {
        timeOut: 3000
      });
    }
  }
  deleteExternalCustomer() {
    this.isExternalCustomerEnabled = false;
    this.stakeHoldersArrayForSetup.splice(5, 1);
  }
  getLocationList: any = [];
  selectedLocationForSetup: any = [];
  getBandList: any = [];
  selectedBandForSetup: any = [];
  getGradeList: any = [];
  selectedGradeForSetup: any = [];
  getFunctionList: any = [];
  selectedFunctionForSetup: any = [];
  selectedEmployeeId: any = [];
  listOfEmployees: any = [];
  reviewDateOfJoining: any;
  getLocationsListForEssSetup() {
    if (this.selectedYear != null) {
      const test = this.selectedYear?.split('-');
      const request = {
        companyId: this.loggedInUserCompanyID,
        endDate: this.selectedReviewEndDate,
        fromYear: test[0],
        location: [],
        toYear: test[1]
      };
      this.httpService.callPostService(this.config.getLocationsListForEssSetup, request).subscribe((data: any) => {
        this.getLocationList = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            name: ele
          };
          this.getLocationList.push(obj);
        });
      });
    }
  }
  getBandsListForEssSetup() {
    const test = this.selectedYear?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: test[0],
      location: this.selectedLocationForSetup?.map((ele: { id: any }) => ele.id),
      toYear: test[1],
      endDate: this.selectedReviewEndDate
    };
    this.httpService.callPostService(this.config.getBandsListForEssSetup, request).subscribe((data: any) => {
      this.getBandList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.getBandList.push(obj);
      });
    });
  }
  getGradesListForEssSetup() {
    const test = this.selectedYear?.split('-');
    const request = {
      band: this.selectedBandForSetup?.map((ele: { id: any }) => ele.id),
      companyId: this.loggedInUserCompanyID,
      fromYear: test[0],
      location: this.selectedLocationForSetup?.map((ele: { id: any }) => ele.id),
      toYear: test[1],
      endDate: this.selectedReviewEndDate
    };
    this.httpService.callPostService(this.config.getGradesListForEssSetup, request).subscribe((data: any) => {
      this.getGradeList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.getGradeList.push(obj);
      });
    });
  }
  getDeptListForEssSetup() {
    const test = this.selectedYear?.split('-');
    const request = {
      band: this.selectedBandForSetup?.map((ele: { id: any }) => ele.id),
      companyId: this.loggedInUserCompanyID,
      fromYear: test[0],
      grade: this.selectedGradeForSetup?.map((ele: { id: any }) => ele.id),
      location: this.selectedLocationForSetup?.map((ele: { id: any }) => ele.id),
      toYear: test[1],
      endDate: this.selectedReviewEndDate
    };
    this.httpService.callPostService(this.config.getDeptListForEssSetup, request).subscribe((data: any) => {
      this.getFunctionList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.getFunctionList.push(obj);
      });
    });
  }
  getEmpListForEssSetup() {
    const test = this.selectedYear?.split('-');
    const request = {
      band: this.selectedBandForSetup?.map((ele: { id: any }) => ele.id),
      companyId: this.loggedInUserCompanyID,
      fromYear: test[0],
      grade: this.selectedGradeForSetup?.map((ele: { id: any }) => ele.id),
      location: this.selectedLocationForSetup?.map((ele: { id: any }) => ele.id),
      toYear: test[1],
      depts: this.selectedFunctionForSetup?.map((ele: { id: any }) => ele.id),
      doj: null,
      endDate: this.selectedReviewEndDate
    };
    this.httpService.callPostService(this.config.getEmpListForEssSetup, request).subscribe((data: any) => {
      this.listOfEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          isChecked: false,
          employeeId: ele.employeeId,
          firstName: ele.firstName,
          lastName: ele.lastName,
          dateOfJoining: ele.dateOfJoining,
          designation: ele.designation,
          department: ele.department,
          reportingManagerName: ele.reportingManagerName,
          officeLocation: ele.workLocationCity,
          band: ele.band,
          grade: ele.grade
        };
        this.listOfEmployees.push(obj);
      });
      this.selectedEmployeeId = this.selectedEmployeeId
        .map((item: any) => {
          if (typeof item === 'object' && item.id) {
            // Find in firstArray and merge if necessary
            const foundItem = this.listOfEmployees.find((emp: any) => emp.id === item.id);
            return foundItem ? { ...foundItem, ...item } : item;
          }
          return this.listOfEmployees.find((emp: any) => emp.id === item) || null; // Get full object if only id is provided
        })
        .filter(Boolean); // Remove null values if no match is foun
    });
  }
  onSelectLocationSetup() {}
  onDeSelectLocationSetup() {
    // if (this.selectedLocationForSetup.length == 0) {
    this.selectedBandForSetup = [];
    this.getBandList = [];
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
    // } else {
    this.getBandsListForEssSetup();
    // }
  }
  selectAllLocationSetup(data: any) {
    this.selectedLocationForSetup = data;
    this.getBandsListForEssSetup();
  }
  onDeSelectAllLocationSetup() {
    this.selectedBandForSetup = [];
    this.getBandList = [];
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
  }

  onSelectBandSetup() {}
  onDeSelectBandSetup() {
    // if (this.selectedBandForSetup.length == 0) {
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
    // } else {
    this.getBandsListForEssSetup();
    // }
  }
  selectAllBandSetup(data: any) {
    this.selectedBandForSetup = data;
    this.getGradesListForEssSetup();
  }
  onDeSelectAllBandSetup() {
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
  }

  onSelectGradeSetup() {}
  onDeSelectGradeSetup() {
    // if (this.selectedGradeForSetup.length == 0) {
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
    // } else {
    this.getDeptListForEssSetup();
    // }
  }
  selectAllGradeSetup(data: any) {
    this.selectedGradeForSetup = data;
    this.getDeptListForEssSetup();
  }
  onDeSelectAllGradeSetup() {
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
  }

  onSelectFunctionSetup() {}
  onDeSelectFunctionSetup() {
    // if (this.selectedFunctionForSetup.length == 0) {
    this.listOfEmployees = [];
    // } else {
    this.getEmpListForEssSetup();
    // }
  }
  selectAllFunctionSetup(data: any) {
    this.selectedFunctionForSetup = data;
  }
  onDeSelectAllFunctionSetup() {
    this.selectedFunctionForSetup = [];
  }
  onClickOpenCreateSurveyPopup(popupName: any) {
    if (popupName == 'Create Instructions') {
      localStorage.removeItem('intructionList');
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      popupName: popupName,
      moduleName: '360',
      year: this.selectedYear,
      selectedLocationForSetup: this.selectedLocationForSetup,
      selectedBandForSetup: this.selectedBandForSetup,
      selectedGradeForSetup: this.selectedGradeForSetup,
      selectedFunctionForSetup: this.selectedFunctionForSetup,
      surveyDateOfJoining: this.reviewDateOfJoining,
      selectedEmployeeId: this.selectedEmployeeId,
      selectedSurveyID: this.selectedReviewID,
      endDate: this.selectedReviewEndDate,
      invitationEmailBody: this.invitationEmailBody,
      invitationEmailSubject: this.invitationEmailSubject,
      submissionEmailBody: this.submissionEmailBody,
      submissionEmailSubject: this.submissionEmailSubject,
      intructionList: this.intructionList,
      isPublished: this.isPublished
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(EssDetailsPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (popupName == 'Create Instructions') {
        this.intructionList = result;
      }
      if (popupName == 'Create Email Body') {
        this.invitationEmailBody = result?.invitationEmailBody;
        this.invitationEmailSubject = result?.invitationEmailSubject;
      }
      if (popupName == 'Submission Email') {
        this.submissionEmailBody = result?.submissionEmailBody;
        this.submissionEmailSubject = result?.submissionEmailSubject;
      }

      if (popupName == 'View Employees') {
        this.selectedEmployeeId = result?.selectedEmployeeId;
      }
    });
  }
  createRatingAddTableRow() {
    this.ratingList.push({
      id: null,
      questionType: 'Rating Based',
      rating: null,
      ratingDefinition: ''
    });
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
  }

  createRatingRemoveTableRow(index: number, item: any) {
    if (this.ratingList.length > 1) {
      this.ratingList.splice(index, 1);
    }
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
    if (item.id) {
      this.removeRatingByID(item.id);
    }
  }
  isOpenEnded: boolean = false;
  isRatingBased: boolean = true;
  onQuestionTypeChange(row: any, index: any) {
    if (row.questionType === 'Open Ended') {
      this.ratingList[index].ratingDefinition = '';
    }
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
  }
  validateInputRating(event: KeyboardEvent): void {
    const pattern = /^[0-9]$/; // Allows only digits (0-9).
    const inputChar = String.fromCharCode(event.keyCode || event.which);

    if (!pattern.test(inputChar)) {
      event.preventDefault(); // Prevent invalid character input.
    }
  }
  selectedTemplateColorName: any = 'Red';
  selectedTemplateColorCode: any = '#F6921E';
  selectedtemplateBgColor: any;
  templateColorList = [
    {
      stripcolor: '#db4437',
      backgroundColor: '#fae3e1',
      colorName: 'Red'
    },
    {
      stripcolor: '#673ab7',
      backgroundColor: '#f0ebf8',
      colorName: 'Purple'
    },
    {
      stripcolor: '#3f51b5',
      backgroundColor: '#eceef8',
      colorName: 'Indigo'
    },
    {
      stripcolor: '#4285f4',
      backgroundColor: '#e3edfd',
      colorName: 'Blue'
    },
    {
      stripcolor: '#03a9f4',
      backgroundColor: '#d9f2fd',
      colorName: 'Light Blue'
    },
    {
      stripcolor: '#00bcd4',
      backgroundColor: '#d9f5f9',
      colorName: 'Cyan'
    },
    {
      stripcolor: '#ff5722',
      backgroundColor: '#ffe6de',
      colorName: 'Red Orange'
    },

    {
      stripcolor: '#ff9800',
      backgroundColor: '#fff0d9',
      colorName: 'Orange'
    },
    {
      stripcolor: '#009688',
      backgroundColor: '#d9efed',
      colorName: 'Teal'
    },
    {
      stripcolor: '#4caf50',
      backgroundColor: '#e4f3e5',
      colorName: 'Green'
    },
    {
      stripcolor: '#607d8b',
      backgroundColor: '#e7ecee',
      colorName: 'Blue Gray'
    },
    {
      stripcolor: '#9e9e9e',
      backgroundColor: '#f0f0f0',
      colorName: 'Gray'
    }
  ];
  searchString: any = '';
  debounceTimer: any;
  listof360Review: any = [];

  defaultCall360ReviewColumn() {
    const objListof360ReviewColumnDef = [
      {
        headerName: '',
        headerCheckboxSelection: true, // ✅ Header checkbox
        checkboxSelection: (params: any) => {
          // ✅ sirf tab checkbox show hoga jab row.status === "Pending"
          return params.data?.reviewStatus === 'Pending';
        },
        width: 60,
        pinned: 'left',
        headerComponentParams: {
          template: `<span id="deleteIcon" 
                            class="material-icons"
                            style="display:flex;align-items:center;justify-content:center;cursor:not-allowed;color:lightgray;">
                       delete
                     </span>`
        }
      },
      {
        headerName: '360 Review Name',
        minWidth: 250,
        filter: 'agSetColumnFilter',
        field: 'reviewName',
        cellRenderer: (params: any) => {
          return `<span class="review-link" style="color:#1976d2;cursor:pointer;text-decoration:underline;">
                    ${params.value}
                  </span>`;
        },
        onCellClicked: (params: any) => {
          // 🔥 Ye Angular component method call karega
          this.onClickEssName(params.data);
        }
      },
      {
        headerName: 'Start date',
        field: 'startDate',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 200,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true, // ✅ AND/OR hide
          maxNumConditions: 1 // ✅ Sirf ek condition allow hogi
        }
      },
      {
        headerName: 'End date',
        field: 'endDate',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 200,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true, // ✅ AND/OR hide
          maxNumConditions: 1 // ✅ Sirf ek condition allow hogi
        }
      },
      {
        headerName: 'Status',
        minWidth: 200,
        filter: 'agSetColumnFilter',
        field: 'reviewStatus',
        cellRenderer: (params: any) => {
          const value = params.value || 'Unknown';
          let color = '#999'; // default gray

          if (value === 'Completed')
            color = '#4caf50'; // green
          else if (value === 'Active')
            color = '#2196f3'; // blue
          else if (value === 'Pending') color = '#ff9800'; // orange (extra case agar ho)

          return `
            <span style="
              border: 1px solid ${color};
              color: ${color};
              background: ${color}15;
              padding: 3px 8px;
              line-height: 1.4em;
              border-radius: 12px;
              font-size: 12px;
              font-weight: 500;
              display: inline-block;
            ">
              ${value}
            </span>
          `;
        }
      }
    ];
    this.listof360ReviewColumnDef = objListof360ReviewColumnDef;
    // Remove where headerName is blank
    const newColumnDef = objListof360ReviewColumnDef.filter(col => col.headerName !== '');
    this.listof360ReviewColumnDefCopyForDailog = newColumnDef;
  }

  getAll360() {
    const test = this.selectedYear?.split('-');
    var srearchString;
    if (this.searchString == '' || this.searchString == null) {
      srearchString = 'All';
    } else {
      srearchString = this.searchString;
    }
    this.httpService.callGetService(this.config.getAll360 + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + srearchString).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listof360Review = data?.data?.review?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.review?.every((ele: any) => ele.reviewStatus == 'Active');
    });
  }

  onSearchInput(event: any) {
    this.searchString = event.target.value;
    if (this.searchString == '') {
      this.searchString = null;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.getAll360();
    }, 300);
  }

  onSortAssending(sortName: any) {
    this.sortByName = sortName;
    const test = this.selectedYear?.split('-');
    var srearchString;
    if (this.searchString == '') {
      srearchString = 'All';
    } else {
      srearchString = this.searchString;
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + srearchString + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + sortName + ',asc').subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listof360Review = data?.data?.review?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.review?.every((ele: any) => ele.reviewStatus == 'Active');
    });
  }
  onSortDesending(sortName: any) {
    this.sortByName = sortName;
    const test = this.selectedYear?.split('-');
    var srearchString;
    if (this.searchString == '') {
      srearchString = 'All';
    } else {
      srearchString = this.searchString;
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + srearchString + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + sortName + ',desc').subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listof360Review = data?.data?.review?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.review?.every((ele: any) => ele.reviewStatus == 'Active');
    });
  }
  totalNoOfPages: any = 0;
  currentPage: any = 1;
  totalCount: any = 0;
  page: any = 0;
  isShowCheckBox: boolean = false;
  selectedSizeToShowData: any = 25;
  sortByName: any;
  pageChangeEss() {
    const test = this.selectedYear?.split('-');
    var srearchString;
    if (this.searchString == '') {
      srearchString = 'All';
    } else {
      srearchString = this.searchString;
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + srearchString + '?page=' + this.page + '&size=' + this.selectedSizeToShowData + '&sort=' + this.sortByName + ',asc').subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listof360Review = data?.data?.ess?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.ess?.every((ele: any) => ele.reviewStatus == 'Active');
    });
  }
  sizeChange() {
    const test = this.selectedYear?.split('-');
    var srearchString;
    if (this.searchString == '') {
      srearchString = 'All';
    } else {
      srearchString = this.searchString;
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + srearchString + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + this.sortByName + ',asc').subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listof360Review = data?.data?.ess?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.ess?.every((ele: any) => ele.reviewStatus == 'Active');
    });
  }
  previousPageEss() {
    if (this.currentPage < 2) {
      return;
    } else {
      this.currentPage--;
      this.page--;
      this.pageChangeEss();
    }
  }
  nextPageEss() {
    if (this.currentPage >= this.currentPage) {
      return;
    }
    if (this.currentPage == 1) {
      this.page = 1;
    } else {
      this.page++;
    }
    this.currentPage++;
    this.pageChangeEss();
  }
  isAllSurveyMaster: boolean = false;
  selectedSurveyMaster: any = [];
  onSelectAllSurveyMaster(event: any) {
    this.selectedSurveyMaster = [];
    if (event.checked) {
      this.isAllSurveyMaster = true;
      this.listof360Review.forEach((ele: any) => {
        if (ele.reviewStatus != 'Active') {
          ele.isChecked = true;
          this.selectedSurveyMaster.push(ele);
        }
      });
    } else {
      this.listof360Review.forEach((ele: any) => {
        ele.isChecked = false;
      });
      this.isAllSurveyMaster = false;
      this.selectedSurveyMaster = [];
    }
  }
  onSelectSingleSurveyMaster(event: any, item: any, index: any) {
    if (event.checked) {
      this.listof360Review[index].isChecked = true;
      this.selectedSurveyMaster.push(item);
    } else {
      this.isAllSurveyMaster = false;
      this.listof360Review[index].isChecked = false;
      this.listof360Review.forEach((ele: any, ind: any) => {
        if (ele.isChecked == false) {
          this.selectedSurveyMaster.splice(ind, 1);
        }
      });
    }
  }
  transformToYear(formYear: any, toYear: any) {
    if (formYear == toYear) {
      return `${formYear}`;
    } else {
      return `${formYear?.toString()}-${toYear.toString()?.slice(-2)}`;
    }
  }
  onClickEssName(data: any) {
    console.log(data);
    if (data?.reviewStatus == 'Pending') {
      return;
    }
    if (data?.reviewStatus == 'Pending') {
      this.router.navigate(['/home/hrportal/threeSixtyDegree', { operation: 'Setup', id: data?.id, year: this.selectedYear }]);
    } else {
      this.selectedReviewID = data?.id;
      this.onClickOpenCreateSurveyPopup('360 Review');
    }
  }
  softDeleteEssByIds() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to delete review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const selectedData = this.gridApi.getSelectedRows();
        console.log('Delete karne ke liye selected rows:', selectedData);
        const request = {
          id: selectedData?.map((ele: any) => ele.id),
          isDeleted: true
        };

        this.httpService.callPostService(this.config.softDelete360ByIds, request).subscribe((data: any) => {
          if (data?.data) {
            this.selectedSurveyMaster = [];
            this.isAllSurveyMaster = false;
            this.getAll360();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {});
          }
        });
      }
    });
  }

  reviewNamesOfUser() {
    this.listofReviewNamesActiveAndCompleted = [];
    // this.listOfEmpForReports = [];
    this.AtoZReportListData = [];
    this.getDumpReportListData = [];
    this.selectedEmployeeForReportForTrendAnalysis = null;
    this.selectedEmployeeForReport = null;
    this.selectedReviewStartDate = null;
    this.selectedReviewEndDate = null;
    const test = this.selectedYear?.split('-');
    this.httpService.callGetService(this.config.reviewNamesOfUser + this.loggedInUserId + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.listofReviewNames = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        };
        this.listofReviewNames.push(obj);
      });
      if (this.selectedTypeTabName == 'Participate in 360 Review') {
        this.intructionList = [];
        // this.getStakeholderRole();
      }
      // this.participatein360ReviewArrayList = [];

      if (this.selectedTypeTabName != 'Reports') {
        if (this.listofReviewNames.length != 0) {
          this.selectedReviewID = this.listofReviewNames[0].id;
          this.selectedReviewName = this.listofReviewNames[0].name;
          // this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
          this.getReviewByID();
          // this.getReview360ByIdAndUser();
        } else {
          this.selectedReviewID = null;
          this.selectedReviewName = null;
          // this.loggedInUserName = null;
          this.selectedStakeholdersEmployeeName = null;
          this.listofStakeHoldersEmployees = [];
          this.participatein360ReviewArrayList = [];
          this.ratingList = [];
        }
      }
    });

    this.reviewNamesActiveAndCompleted();
  }
  listofStakeHoldersEmployees: any = [];
  selectedStakeholdersEmployeeId: any;
  selectedStakeholdersEmployeeName: any;
  getEmployeeNamesByReviewIDUserId() {
    const name = this.listofReviewNames?.find((ele: any) => ele.id == this.selectedReviewID);
    this.selectedReviewName = name?.name;
    this.httpService.callGetService(this.config.getEmployeeNamesByReviewIDUserId + this.selectedReviewID + '/' + this.loggedInUserId).subscribe((data: any) => {
      this.listofStakeHoldersEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        };
        this.listofStakeHoldersEmployees.push(obj);
      });
      if (this.listofStakeHoldersEmployees.length != 0) {
        this.selectedStakeholdersEmployeeId = this.listofStakeHoldersEmployees[0].id;
        this.selectedStakeholdersEmployeeName = this.listofStakeHoldersEmployees[0].name;
        this.getReview360ByIdAndUser();
      } else {
        this.selectedStakeholdersEmployeeId = null;
        this.selectedStakeholdersEmployeeName = null;
      }
    });
  }
  changeStakeholderEmployee() {
    const name = this.listofStakeHoldersEmployees?.find((ele: any) => ele.id == this.selectedStakeholdersEmployeeId);
    this.selectedStakeholdersEmployeeName = name?.name;
    this.getReview360ByIdAndUser();
  }
  stakeholderRolesListByReviewID: any = [];

  getStakeholderRole() {
    this.httpService.callGetService(this.config.getStakeholderRole + this.selectedReviewID + '/' + this.selectedStakeholdersEmployeeId + '/' + this.loggedInUserId).subscribe((data: any) => {
      this.stakeholderRolesListByReviewID = [];
      //     data?.data.forEach((ele: any) => {
      //       let obj = {
      //         roleType: ele,
      //         isSubmitted: false,
      //         submissionDate: null
      //       }
      console.log('stakeHoldersArrayForSetup: ' + JSON.stringify(this.stakeHoldersArrayForSetup));

      const selectedStakeholders = this.stakeHoldersArrayForSetup.filter((s: { selected: any }) => s.selected);
      console.log(selectedStakeholders);

      selectedStakeholders.forEach((stakeholder: any) => {
        // Only create a role if it exists in API data
        if (data?.data.includes(stakeholder.name)) {
          const obj = {
            roleType: stakeholder.name,
            isSubmitted: false,
            submissionDate: null
          };
          this.stakeholderRolesListByReviewID.push(obj);
        }
      });

      this.participatein360ReviewArrayList.forEach((category: any) => {
        category.questions.forEach((question: any) => {
          // Initialize 'answers' if it's undefined
          if (!question.answers) {
            question.answers = {};
          }

          // Initialize each stakeholder role in 'answers'
          this.stakeholderRolesListByReviewID.forEach((stakeholder: any) => {
            if (question.answers[stakeholder.roleType] === undefined) {
              question.answers[stakeholder.roleType] = question.questionType === 'Open Ended' ? '' : null;
            }
          });
        });
      });
      this.getResponseOfReview();
      this.getIsResponseSubmitted();
    });
  }
  onClickSaveResponse(stakeholderType: any, submitFlag: any, type: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to ' + type + ' Review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.submitResponseOfReview(stakeholderType, submitFlag);
      }
    });
  }

  submitResponseOfReview(stakeholderType: any, submitFlag: any) {
    var questionResponses = this.participatein360ReviewArrayList.flatMap((category: any) =>
      category.questions.map((question: any) => ({
        answer: question.answers[stakeholderType] || '',
        questionId: question.id
      }))
    );
    if (questionResponses?.some((ele: any) => ele.answer == '')) {
      this.toastr.error('Please fill all mandetory fields.', '', {
        timeOut: 3000
      });
      return;
    }
    const request = {
      questionResponses: questionResponses,
      reviewId: this.selectedReviewID,
      roleType: stakeholderType,
      userId: this.selectedStakeholdersEmployeeId,
      userLogged: Number(this.loggedInUserId),
      isSubmitted: submitFlag
    };
    // this.loader.simpleLoader();
    // this.httpService.callPostService(this.config.submitResponseOfReview, request).subscribe((data: any) => {
    //   // this.loader.dismissLoader();
    //   if (data?.status) {
    //     const stakeholder = this.stakeholderRolesListByReviewID.find(
    //       (s: any) => s.roleType === stakeholderType
    //     );
    //     if (submitFlag) {
    //       stakeholder.isSubmitted = true;
    //       // stakeholder.submissionDate = new Date();
    //     }
    //     const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
    //       disableClose: true,
    //       height: '25%',
    //       width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
    //       maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
    //       data: {
    //         msg: 'Response saved successfully.',
    //         btn2: 'OK',
    //         btn2BgColor: this.buttonColorName,
    //         showSuccessIcon: true,
    //         showSuccessMessage: false,
    //         showCloseIcon: false
    //       },
    //     });
    //     successdialogRef.afterClosed().subscribe(result => {
    //       this.getIsResponseSubmitted();
    //     });
    //   }
    // }, (error) => {
    //   if (error) {
    //     this.loader.dismissLoader();
    //   }
    // })
    this.httpService.callPostService(this.config.submitResponseOfReview, request).subscribe({
      next: (data: any) => {
        this.loader.dismissLoader();

        if (data?.status) {
          // ✅ Find stakeholder
          const stakeholder = this.stakeholderRolesListByReviewID.find((s: any) => s.roleType === stakeholderType);

          if (submitFlag) {
            stakeholder.isSubmitted = true;
            // stakeholder.submissionDate = new Date();
          }

          // ✅ Success dialog
          const successDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
            maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
            data: {
              msg: data?.message || 'Response saved successfully.',
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          successDialogRef.afterClosed().subscribe(() => {
            this.getIsResponseSubmitted();
          });
        } else {
          // ❌ Backend returned failure (status = false)
          this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
            data: {
              msg: data?.message || 'Failed to save response. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red',
              showSuccessIcon: false,
              showCloseIcon: false
            }
          });
        }
      },
      error: error => {
        this.loader.dismissLoader();
        console.error('Error saving review response:', error);

        // 🧱 Network or server error handling
        this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
          data: {
            msg: error?.error?.message || 'An unexpected error occurred. Please try again later.',
            btn2: 'OK',
            btn2BgColor: 'red',
            showSuccessIcon: false,
            showCloseIcon: false
          }
        });
      },
      complete: () => {
        console.log('Submit response API call completed');
      }
    });
  }

  // Submit all
  submitAllResponseOfReview(submitFlag: any, type: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to ' + type + ' all Review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var requestObj: any = [];
        for (let i = 0; i < this.stakeholderRolesListByReviewID.length; i++) {
          var questionResponses = this.participatein360ReviewArrayList.flatMap((category: any) =>
            category.questions.map((question: any) => ({
              answer: question.answers[this.stakeholderRolesListByReviewID[i].roleType] || '',
              questionId: question.id
            }))
          );
          requestObj.push({
            isSubmitted: submitFlag,
            questionResponses: questionResponses,
            reviewId: this.selectedReviewID,
            roleType: this.stakeholderRolesListByReviewID[i].roleType,
            userId: this.selectedStakeholdersEmployeeId,
            userLogged: Number(this.loggedInUserId)
          });
        }
        console.warn(requestObj);

        if (requestObj.some((review: any) => review.questionResponses.some((q: any) => q.answer.trim() === ''))) {
          this.toastr.error('Please fill all mandetory fields.', '', {
            timeOut: 3000
          });
          return;
        }
        const request = requestObj;
        // this.loader.simpleLoader();
        // this.httpService.callPostService(this.config.submitAllResponseOfReview, request).subscribe((data: any) => {
        //   this.loader.dismissLoader();
        //   if (data?.status) {
        //     const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
        //       disableClose: true,
        //       height: '25%',
        //       width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
        //       maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
        //       data: {
        //         msg: data.message,
        //         btn2: 'OK',
        //         btn2BgColor: this.buttonColorName,
        //         showSuccessIcon: true,
        //         showSuccessMessage: false,
        //         showCloseIcon: false
        //       },
        //     });
        //     successdialogRef.afterClosed().subscribe(result => {
        //       this.getIsResponseSubmitted();
        //     });
        //   }
        // })
        this.httpService.callPostService(this.config.submitAllResponseOfReview, request).subscribe({
          next: (data: any) => {
            this.loader.dismissLoader();

            if (data?.status) {
              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
                maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
                data: {
                  msg: data.message,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });

              successdialogRef.afterClosed().subscribe(() => {
                this.getIsResponseSubmitted();
              });
            } else {
              // Handle backend "failure" response (e.g. status=false)
              this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
                data: {
                  msg: data?.message || 'Something went wrong.',
                  btn2: 'OK',
                  btn2BgColor: 'red',
                  showSuccessIcon: false,
                  showCloseIcon: false
                }
              });
            }
          },
          error: err => {
            this.loader.dismissLoader();
            console.error('Error submitting review response:', err);

            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: err?.error?.message || 'An unexpected error occurred. Please try again later.',
                btn2: 'OK',
                btn2BgColor: 'red',
                showSuccessIcon: false,
                showCloseIcon: false
              }
            });
          },
          complete: () => {
            console.log('Submit all review responses - request completed');
          }
        });
      }
    });
  }
  isAllResponseSubmitted: boolean = false;

  getIsResponseSubmitted() {
    this.httpService.callGetService(this.config.getIsResponseSubmitted + this.selectedReviewID + '/' + this.selectedStakeholdersEmployeeId + '/' + this.loggedInUserId).subscribe((data: any) => {
      this.isAllResponseSubmitted = false;
      if (data?.data?.length != 0) {
        for (let j = 0; j < this.stakeholderRolesListByReviewID?.length; j++) {
          for (let i = 0; i < data?.data?.length; i++) {
            if (data?.data[i]?.roleType == this.stakeholderRolesListByReviewID[j].roleType) {
              this.stakeholderRolesListByReviewID[j].isSubmitted = true;
              this.stakeholderRolesListByReviewID[j].submissionDate = data?.data[i]?.submissionDate;
            }
          }
        }
        this.isAllResponseSubmitted = this.stakeholderRolesListByReviewID?.every((ele: any) => ele.isSubmitted == true);
      }
    });
  }

  getResponseOfReview() {
    this.httpService.callGetService(this.config.getResponseOfReview + this.selectedReviewID + '/' + this.selectedStakeholdersEmployeeId + '/' + this.loggedInUserId).subscribe((data: any) => {
      if (data?.data?.length != 0) {
        this.participatein360ReviewArrayList.forEach((competency: any) => {
          competency.questions.forEach((question: any) => {
            data?.data?.forEach((item: any) => {
              if (item.competencyName === competency.competencyName) {
                item.questions.forEach((q: any) => {
                  if (q.questionId === question.id) {
                    question.answers[item.roleType] = q.answer;
                  }
                });
              }
            });
          });
        });
      } else {
        this.participatein360ReviewArrayList.forEach((category: any) => {
          category.questions.forEach((question: any) => {
            // Initialize 'answers' if it's undefined
            if (question.answers) {
              question.answers = {};
            }

            // Initialize each stakeholder role in 'answers'
            this.stakeholderRolesListByReviewID.forEach((stakeholder: any) => {
              if (question.answers[stakeholder.roleType] === undefined) {
                question.answers[stakeholder.roleType] = question.questionType === 'Open Ended' ? '' : null;
              }
            });
          });
        });
      }
    });
  }
  listOfEmpForReports: any = [];
  getEmpNamesBy360Id() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewID + '/' + isEmployee).subscribe((data: any) => {
      this.listOfEmpForReports = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        };
        this.listOfEmpForReports.push(obj);
      });
      this.listOfEmpForQuestionWise = this.listOfEmpForReports;
      this.listOfEmpForStakeholderWise = this.listOfEmpForReports;
      this.listOfEmpForTopandBottomWise = this.listOfEmpForReports;
      this.listOfEmpForSpiderGraph = this.listOfEmpForReports;

      if (window.innerWidth <= 800) {
        this.selectedEmployeeForReport = this.listOfEmpForReports[0].id;
      } else {
        this.selectedEmployeeForReport = this.listOfEmpForReports;
      }
      if (this.listOfEmpForReports.length != 0) {
        this.selectedEmployeeForReportForTrendAnalysis = this.listOfEmpForReports[0].id;
        this.selectedEmployeeCompetencyWiseGraph = this.listOfEmpForReports[0].id;
        this.selectedEmployeeQuestionWiseGraph = this.listOfEmpForReports[0].id;
        this.selectedEmployeeStakeholderWise = this.listOfEmpForReports[0].id;
        this.selectedEmployeeForTopandBottom = this.listOfEmpForReports[0].id;
        this.selectedEmployeeForSpiderGraph = this.listOfEmpForReports[0].id;
      } else {
        this.selectedEmployeeForReportForTrendAnalysis = null;
        this.selectedEmployeeCompetencyWiseGraph = null;
        this.selectedEmployeeQuestionWiseGraph = null;
        this.selectedEmployeeStakeholderWise = null;
        this.selectedEmployeeForTopandBottom = null;
        this.selectedEmployeeForSpiderGraph = null;
      }
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        this.selectedEmployeeCompetencyWiseGraph = this.loggedInUserId;
        this.selectedEmployeeQuestionWiseGraph = this.loggedInUserId;
        this.selectedEmployeeStakeholderWise = this.loggedInUserId;
        this.selectedEmployeeForTopandBottom = this.loggedInUserId;
        this.selectedEmployeeForSpiderGraph = this.loggedInUserId;
        this.selectedEmployeeForReportForTrendAnalysis = this.loggedInUserId;
        this.selectedEmployeeForReport = [];
        if (window.innerWidth <= 800) {
          this.selectedEmployeeForReport = Number(this.loggedInUserId);
        } else {
          this.selectedEmployeeForReport.push({ id: Number(this.loggedInUserId), name: '' });
        }
      } else {
      }
      this.getCompletionStatusGraph();
      this.getQuestionWiseStatusGraph();
      this.getStakeholderWiseGraph();
      this.getTopVsBottomAnalysisGraph();
      this.getSpiderWebGraph();
    });
  }

  getEmpNameForReport() {
    let isEmployee: any;
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      isEmployee = false;
    } else {
      isEmployee = true;
    }
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewID + '/' + isEmployee).subscribe((data: any) => {
      this.listOfEmpForReports = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        };
        this.listOfEmpForReports.push(obj);
      });
      if (window.innerWidth <= 800) {
        this.selectedEmployeeForReport = this.listOfEmpForReports[0].id;
      } else {
        this.selectedEmployeeForReport = this.listOfEmpForReports;
      }
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        if (window.innerWidth <= 800) {
          this.selectedEmployeeForReport = Number(this.loggedInUserId);
        } else {
          this.selectedEmployeeForReport.push({ id: Number(this.loggedInUserId), name: '' });
        }
        this.selectedEmployeeForReportForTrendAnalysis = this.loggedInUserId;
      } else {
        if (this.listOfEmpForReports.length != 0) {
          this.selectedEmployeeForReportForTrendAnalysis = this.listOfEmpForReports[0].id;
        } else {
          this.selectedEmployeeForReportForTrendAnalysis = null;
        }
      }

      if (this.selectedSubTab == 'A-Z report') {
        this.getAtoZReport();
      }
      if (this.selectedSubTab == 'Trend analysis report') {
        this.getTrendAnalysisReport();
      }
      if (this.selectedSubTab == 'Dump Report') {
        this.getDumpReport();
      }
    });
  }

  getEmpForScoreGiveYouReport() {
    let isEmployee: boolean = false;
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
      isEmployee = true;
    } else {
      isEmployee = false;
    }
    this.httpService.callGetService(this.config.getAllStakeholders + this.selectedReviewID + '/' + isEmployee).subscribe((data: any) => {
      this.listOfEmpForReports = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        };
        this.listOfEmpForReports.push(obj);
        if (this.listOfEmpForReports.length !== 0) {
          if (window.innerWidth <= 800) {
            this.selectedEmployeeForReport = this.listOfEmpForReports[0].id;
          } else {
            this.selectedEmployeeForReport = this.listOfEmpForReports;
          }
        }
      });
      if (this.listOfEmpForReports.length != 0) {
        this.selectedEmployeeForReportForTrendAnalysis = this.listOfEmpForReports[0].id;
      } else {
        this.selectedEmployeeForReportForTrendAnalysis = null;
      }
      this.getScoreGivenByYouReport();
    });
  }

  selectedEmployeeForReport: any = [];
  selectedEmployeeForReportForTrendAnalysis: any;

  onChangeReviewNameOfReport() {
    if (this.selectedSubTab == 'A-Z report') {
      this.getEmpNameForReport();
    }
    if (this.selectedSubTab == 'Trend analysis report') {
      this.getEmpNameForReport();
    }
    if (this.selectedSubTab == 'Score given by you report') {
      this.getEmpForScoreGiveYouReport();
    }
    if (this.selectedSubTab == 'Dump Report') {
      this.getEmpNameForReport();
    }

    // if (this.selectedSubTab == 'A-Z report') {
    //   this.getAtoZReport();
    // }
    // if (this.selectedSubTab == 'Trend analysis report') {
    //   this.getTrendAnalysisReport();
    // }
    // if (this.selectedSubTab == 'Score given by you report') {
    //   this.getEmpForScoreGiveYouReport();
    //   this.listOfEmpForReports = [];
    // }
    // if (this.selectedSubTab == 'Dump Report') {
    //   this.getDumpReport();
    // }
  }

  onChangegetReportData() {
    if (this.selectedSubTab == 'A-Z report') {
      this.getAtoZReport();
    }
    if (this.selectedSubTab == 'Trend analysis report') {
      this.getTrendAnalysisReport();
    }
    if (this.selectedSubTab == 'Score given by you report') {
      this.getScoreGivenByYouReport();
    }
    if (this.selectedSubTab == 'Dump Report') {
      this.getDumpReport();
    }
  }

  AtoZReportListData: any = [];
  selfWeightageReport: any;
  superiorWeightageReport: any;
  subordinateWeightageReport: any;
  peerWeightageReport: any;
  internalCustomerWeightageReport: any;
  externalCustomerWeightageReport: any;
  trendAnalysisListData: any = [];
  getScoreGivenByYouReportListData: any = [];
  getDumpReportListData: any = [];

  searchAtoZReport: any;

  getAtoZReport() {
    const test = this.selectedYear?.split('-');
    let userID: any;
    if (window.innerWidth <= 800) {
      userID = [this.selectedEmployeeForReport];
    } else {
      const ids = this.selectedEmployeeForReport.map((ele: any) => ele.id);
      userID = Array.from(new Set(ids)); // Remove duplicates
    }

    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: test[0],
      reviewId: this.selectedReviewID,
      search: this.searchAtoZReport || null,
      toYear: test[1],
      userId: userID
    };
    console.warn(request);

    this.httpService.callPostService(this.config.getAtoZReport, request).subscribe((data: any) => {
      if (data?.data) {
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'PHI Admin') {
          this.AtoZReportListData = data?.data?.employees;
        } else {
          const filterList = data?.data?.employees;
          let AtoZReportList = filterList.filter((ele: any) => ele.userId === Number(this.loggedInUserId));
          this.AtoZReportListData = AtoZReportList;
        }
        this.selfWeightageReport = data?.data?.selfWeightage;
        this.superiorWeightageReport = data?.data?.superiorWeightage;
        this.subordinateWeightageReport = data?.data?.subordinateWeightage;
        this.peerWeightageReport = data?.data?.peerWeightage;
        this.internalCustomerWeightageReport = data?.data?.internalCustomerWeightage;
        this.externalCustomerWeightageReport = data?.data?.externalCustomerWeightage;

        this.initAtoZGrids();
      }
    });
  }

  onSearchAtoZReport(event: any) {
    this.searchAtoZReport = event.target.value;
    if (this.searchAtoZReport == '') {
      this.searchAtoZReport = null;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.getAtoZReport();
    }, 300);
  }

  competencyListData: any = [];
  getTrendAnalysisReport() {
    console.warn('id', this.selectedEmployeeForReportForTrendAnalysis);

    const test = this.selectedYear?.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: null,
      reviewId: null,
      toYear: null,
      userId: [this.selectedEmployeeForReportForTrendAnalysis]
    };
    this.httpService.callPostService(this.config.getTrendAnalysisReport, request).subscribe((data: any) => {
      if (data?.data) {
        this.trendAnalysisListData = data?.data;
      }
      this.getCompetencyDropdown360Report();
    });
  }
  selectedCompetencyForReport: any;
  getCompetencyDropdown360Report() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: null,
      reviewId: null,
      toYear: null,
      userId: [this.selectedEmployeeForReportForTrendAnalysis]
    };
    this.httpService.callPostService(this.config.getCompetencyDropdown360Report, request).subscribe((data: any) => {
      if (data?.data) {
        this.competencyListData = data?.data;
        if (this.competencyListData.length != 0) {
          this.selectedCompetencyForReport = this.competencyListData[0].competencyName;
          this.getCompetencyTrendAnalysisReport();
        } else {
          this.selectedCompetencyForReport = null;
          this.competencyWiseTrendAnalysisReport = [];
        }
      }
    });
  }
  competencyWiseTrendAnalysisReport: any = [];
  getCompetencyTrendAnalysisReport() {
    this.httpService.callGetService(this.config.getCompetencyTrendAnalysisReport + this.selectedCompetencyForReport + '/' + this.selectedEmployeeForReportForTrendAnalysis).subscribe((data: any) => {
      this.competencyWiseTrendAnalysisReport = data?.data;
    });
  }
  getScoreGivenByYouReport() {
    const test = this.selectedYear?.split('-');
    let userID = [];
    if ((this.selectedSubTab === 'A-Z report' || this.selectedSubTab === 'Score given by you report') && (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin')) {
      let userId: any;
      if (window.innerWidth <= 800) {
        userId = [this.selectedEmployeeForReport];
      } else {
        userId = this.selectedEmployeeForReport.map((ele: any) => ele.id);
      }

      userID = userId;
    } else if ((this.selectedSubTab === 'Trend analysis report' && (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin')) || (this.selectedSubTab === 'Score given by you report' && (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager'))) {
      userID.push(this.selectedEmployeeForReportForTrendAnalysis);
    }
    let isEmployee: boolean = false;
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
      isEmployee = true;
    } else {
      isEmployee = false;
    }
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: null,
      reviewId: this.selectedReviewID,
      toYear: null,
      userId: userID,
      isEmployee: isEmployee
      // "userId": this.selectedEmployeeForReport.map((ele: any) => ele.id)
    };
    this.httpService.callPostService(this.config.getScoreGivenByYouReport, request).subscribe((data: any) => {
      if (data?.data) {
        this.getScoreGivenByYouReportListData = data?.data?.stakeholders;
      }
    });
  }

  getDumpReport() {
    const test = this.selectedYear?.split('-');
    let userID: any;
    if (window.innerWidth <= 800) {
      userID = [this.selectedEmployeeForReport];
    } else {
      userID = this.selectedEmployeeForReport.map((ele: any) => ele.id);
    }

    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: null,
      reviewId: this.selectedReviewID,
      search: this.dumpReportSearchString || null,
      toYear: null,
      userId: userID
    };
    this.getDumpReportListData = [];
    this.httpService.callPostService(this.config.getDumpReport, request).subscribe((data: any) => {
      if (data?.data) {
        this.getDumpReportListData.push(data?.data);
        this.prepareColumns();
        this.prepareRows(this.getDumpReportListData);
        this.pinnedBottomRowData = this.getTotalRow(this.getDumpReportListData);
        console.log('-----------------------------------4777-------------------------', this.getDumpReportListData);
      }
    });
  }
  dumpReportSearchString: any;
  onSearchDumpReport(event: any) {
    this.dumpReportSearchString = event.target.value;
    if (this.dumpReportSearchString == '') {
      this.dumpReportSearchString = null;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.getDumpReport();
    }, 300);
  }

  getTotalColumnsForCompetency(column: any): number {
    let total = 0;
    column.questions.forEach((question: string) => {
      total += this.getQuestionScoreCount(column.competencyName, question).length;
    });
    return total;
  }

  getQuestionScoreCount(competencyName: string, question: string): number[] {
    let maxCount = 1;
    this.getDumpReportListData?.[0]?.data?.forEach((feedback: any) => {
      // console.log("list is.....",   this.getDumpReportListData);

      const comp = feedback.competencyScores?.find((c: any) => c.competencyName === competencyName);

      if (comp) {
        const count = comp.questionScores?.filter((q: any) => q.question === question)?.length || 0;

        if (count > maxCount) {
          maxCount = count;
        }
      }
    });

    return Array.from({ length: maxCount }, (_, i) => i);
  }

  getScore(feedback: any, competencyName: string, question: string): number | null {
    const matchingCompetencies = feedback.competencyScores?.filter((c: any) => c.competencyName?.toLowerCase() === competencyName?.toLowerCase());

    if (!matchingCompetencies?.length) return null;

    // Flatten all questionScores from matching competencies
    const allQuestions = matchingCompetencies.flatMap((c: any) => c.questionScores ?? []);

    const questionMatch = allQuestions.find((qs: any) => qs.question === question);

    return questionMatch?.score ?? null;
  }

  getTotalScore(competencyName: string, question: string): number {
    let total = 0;

    this.getDumpReportListData?.[0]?.data?.forEach((feedback: any) => {
      // Get all competencies that match name (case-insensitive)
      const matchingCompetencies = feedback.competencyScores?.filter((c: any) => c.competencyName?.toLowerCase() === competencyName?.toLowerCase());

      if (!matchingCompetencies?.length) return;

      // Flatten all questionScores from all matching competencies
      const allQuestions = matchingCompetencies.flatMap((c: any) => c.questionScores ?? []);

      // Find the question
      const questionMatch = allQuestions.find((qs: any) => qs.question === question);

      if (questionMatch?.score) {
        const scoreValue = Number(questionMatch.score);
        if (!isNaN(scoreValue)) {
          total += scoreValue;
        }
      }
    });

    return total;
  }

  onChangeGolbalDashboardReview() {
    this.selectedReviewCompetencyWiseID = this.selectedReviewGlobalDashboardID;
    this.selectedReviewQuestionWiseID = this.selectedReviewGlobalDashboardID;
    this.selectedReviewSatkeholderWiseID = this.selectedReviewGlobalDashboardID;
    this.selectedReviewHowDidFareWiseID = this.selectedReviewGlobalDashboardID;
    this.selectedReviewTopandBottomId = this.selectedReviewGlobalDashboardID;
    this.selectedReviewSpidergraphId = this.selectedReviewGlobalDashboardID;
    this.selectedReviewID = this.selectedReviewGlobalDashboardID;
    let reviewNamefied = this.listofReviewNamesActiveAndCompleted.filter((e: any) => e.id == this.selectedReviewGlobalDashboardID);

    this.reviewName = reviewNamefied[0]?.name;
    // this.getReviewByIdForDashboard()
    this.getBandNamesReviewId();
    this.getCompletionStatusGraph();
    this.getCompetencyNamesBy360Id();
    this.getEmpNamesBy360IdStakeholderWiseGraph();
    this.getHowDidIFareGraph();
    this.getEmpNamesBy360IdTopandBottomWiseGraph();
    this.getEmpNamesBy360IdSpiderGraph();
    this.getReviewByID();

    // console.log(this.selectedReviewGlobalDashboardID);
  }

  reviewCounterCount: any = 0;
  get360Counter() {
    var test = this.selectedYear.split('-');
    this.httpService.callGetService(this.config.get360Counter + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.reviewCounterCount = data?.data;
      this.switchspiderWebGraphType('bar');
    });
  }

  isDownload: boolean = true;

  onClickDownloadScoresOfSurveys(id: any) {
    this.isDownload = false;
    const tableId = id;
    const table = document.getElementById(tableId) as HTMLTableElement;
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
    if (!table) {
      alert('Table not found!');
      return;
    }
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${tableId}_${formattedDate}.xlsx`);
    this.isDownload = true;
    this.loader.dismissLoader();
  }

  removeRatingByID(id: any) {
    this.httpService.callGetService(this.config.removeRatingByID + id).subscribe((data: any) => {});
  }
  countTotalQuestion(data: any) {
    const totalQuestions = data?.competency.reduce((sum: any, competency: any) => {
      return sum + competency.questions.length;
    }, 0);
    return totalQuestions;
  }

  downloadCompetencyWiseGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearCompetencyWise);
    const review = this.listofReviewNamesActiveAndCompletedCompetencyWise.find((ele: any) => ele.id === this.selectedReviewCompetencyWiseID);
    const employee = this.empListForCompetencyWiseGraph.find((ele: any) => ele.id === this.selectedEmployeeCompetencyWiseGraph);
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'competencyWiseGraph', // chartId
      'competencyWiseTable', // tableId
      'Competency Wise', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      this.selectedBandCompetencyWiseGraph, // Band
      null, // Competency Name
      employee?.name ? employee?.name : null, // Employee Name
      null // Type
    );
  }

  downloadQuestionWiseGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearQuestionWise);
    const review = this.listofReviewNamesActiveAndCompletedQuestionWise.find((ele: any) => ele.id === this.selectedReviewQuestionWiseID);
    const competencName = this.competencylistForQuestionWiseGraph.find((ele: any) => ele.id === this.selectedCompetencyQuestionWise);
    const employee = this.listOfEmpForQuestionWise.find((ele: any) => ele.id === this.selectedEmployeeQuestionWiseGraph);
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'questionWiseGraph', // chartId
      'questionWiseTable', // tableId
      'Question Wise', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      null, // Band
      competencName?.competencyName ? competencName?.competencyName : null, // Competency Name
      employee?.name ? employee?.name : null, // Employee Name
      null // Type
    );
  }

  downloadStakeholderWiseGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearStakeholderWise);
    const review = this.listofReviewNamesActiveAndCompletedSatkeholderWise.find((ele: any) => ele.id === this.selectedReviewSatkeholderWiseID);
    const employee = this.listOfEmpForStakeholderWise.find((ele: any) => ele.id === this.selectedEmployeeStakeholderWise);
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'stakeholderWiseGraph', // chartId
      'stakeholderWiseTable', // tableId
      'Stakeholder Wise', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      null, // Band
      null, // Competency Name
      employee?.name ? employee?.name : null, // Employee Name
      null // Type
    );
  }

  downloadHowDidIFareGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearHowDidFareWise);
    const review = this.listofReviewNamesActiveAndCompletedHowDidIFareWise.find((ele: any) => ele.id === this.selectedReviewHowDidFareWiseID);
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'HowDidIFareDashboardGraph', // chartId
      'HowDidIFareDashboardTable', // tableId
      'How did I fare in this 360 dashboard', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      null, // Band
      null, // Competency Name
      null, // Employee Name
      null // Type
    );
  }

  downloadTopVsBottomAnalysisGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearTopandBottom);
    const review = this.listofReviewNamesActiveAndCompletedTopandBottomWise.find((ele: any) => ele.id === this.selectedReviewTopandBottomId);
    const employee = this.listOfEmpForTopandBottomWise.find((ele: any) => ele.id === this.selectedEmployeeForTopandBottom);

    const hideEmployeeForRoles = ['Employee', 'HOD', 'Manager'];
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'topToBottomAnalysisGraph', // chartId
      null, // tableId
      'Top 2 vs Bottom 2 Analysis', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      null, // Band
      null, // Competency Name
      // employee?.name, // Employee Name
      hideEmployeeForRoles.includes(this.loggedInUserRole) ? null : employee?.name,
      this.istopandbottomAnalysis ? 'Top' : 'Bottom' // Type
    );
  }

  downloadSpiderWebGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearSpiderWeb);
    const review = this.listofReviewNamesActiveAndCompletedSpiderGraph.find((ele: any) => ele.id === this.selectedReviewSpidergraphId);
    const employee = this.listOfEmpForSpiderGraph.find((ele: any) => ele.id === this.selectedEmployeeForSpiderGraph);
    const hideEmployeeForRoles = ['Employee', 'HOD', 'Manager'];
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'spiderWebGraph', // chartId
      null, // tableId
      'Spider Web', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      null, // Band
      null, // Competency Name
      hideEmployeeForRoles.includes(this.loggedInUserRole) ? null : employee?.name, //Employee name
      null // Type
    );
  }

  latestSelectedDate: any = null; // Track last selected date
  selectedDatesForReminder: any[] = [];

  addDate(date: any) {
    if (!date) return;

    // Create a new Date object from the selected date
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0); // Normalize to midnight (local time)

    // Convert to 'YYYY-MM-DD' format without UTC shift
    const dateString = selectedDate.getFullYear() + '-' + String(selectedDate.getMonth() + 1).padStart(2, '0') + '-' + String(selectedDate.getDate()).padStart(2, '0');

    // Toggle date selection
    const index = this.selectedDatesForReminder.indexOf(dateString);
    if (index === -1) {
      this.selectedDatesForReminder.push(dateString);
    } else {
      this.selectedDatesForReminder.splice(index, 1);
    }
    if (this.selectedDatesForReminder.length === 0) {
      this.latestSelectedDate = null;
    }
  }

  removeDate(date: any) {
    const dateString = new Date(date).toISOString().split('T')[0]; // Convert to 'YYYY-MM-DD'

    this.selectedDatesForReminder = this.selectedDatesForReminder.filter(d => d !== dateString);
    if (this.selectedDatesForReminder.length === 0) {
      this.latestSelectedDate = null;
    }
  }

  dateClass = (d: Date) => {
    const dateToCheck = new Date(d);
    dateToCheck.setHours(0, 0, 0, 0); // Normalize

    return this.selectedDatesForReminder.some(dateStr => {
      const storedDate = new Date(dateStr); // Convert back to Date
      storedDate.setHours(0, 0, 0, 0); // Normalize
      return storedDate.getTime() === dateToCheck.getTime();
    })
      ? 'selected-date'
      : '';
  };

  onClickDownloadScoreGivenByYouReportPDF(id: any) {}

  // dateClass = (date: Date): string => {
  //   const dateString = date.getFullYear() + '-' +
  //     String(date.getMonth() + 1).padStart(2, '0') + '-' +
  //     String(date.getDate()).padStart(2, '0');

  //   return this.selectedDatesForReminder.includes(dateString) ? 'selected-date' : '';
  // };

  onSearchtrendAnalysisReporInput(data: any) {
    var search = '';
    this.trendAnalysisReportSearch = data;
    if (data == '') {
      this.trendAnalysisReportSearch = null;
      // this.getTrendAnalysisReport();
      return;
    }
    if (data.length > 0) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            // this.getTrendAnalysisReport();
          }, 500);
        }
      }, 1500);
    }
  }

  getReview360ByIdAndUser() {
    const request = {
      id: this.selectedReviewID,
      search: null,
      userId: this.selectedStakeholdersEmployeeId
    };
    this.httpService.callPostService(this.config.review360ByIdAndUser, request).subscribe((data: any) => {
      this.ratingBasedList = [];
      if (data?.data?.ratings?.length != 0) {
        this.ratingList = data?.data?.ratings;
        data?.data?.ratings?.forEach((ele: any) => {
          if (ele.questionType == 'Rating Based') {
            let obj = {
              id: ele.id,
              questionType: ele.questionType,
              rating: ele.rating,
              ratingDefinition: ele.ratingDefinition
            };
            this.ratingBasedList.push(obj);
          }
        });
      } else {
        this.ratingList = [
          {
            id: null,
            questionType: 'Rating Based',
            rating: null,
            ratingDefinition: ''
          }
        ];
      }

      this.participatein360ReviewArrayList = data?.data?.competencies
        ?.flatMap((item: any) => item.competencies)
        .reduce(
          (acc: any, curr: any) => {
            const existing = acc.find((comp: any) => comp.competencyName === curr.competencyName);
            if (existing) {
              existing.questions.push(...curr.questions);
            } else {
              acc.push({ competencyName: curr.competencyName, questions: [...curr.questions] });
            }
            return acc;
          },
          [] as { competencyName: string; questions: { id: number; question: string; questionType: string; answers: any }[] }[]
        );
      console.warn('participatein360ReviewArrayList', this.participatein360ReviewArrayList);

      this.getStakeholderRole();
    });
  }

  onChange360Year() {
    this.isCheckSave = true;
    this.isEditActive = false;
    this.selectedReviewName = null;
    this.selectedReviewStartDate = null;
    this.selectedReviewEndDate = null;
    this.isPublished = false;
    this.stakeHoldersArrayForSetup = [
      { name: 'Self', selected: false, weightage: 0 },
      { name: 'Superior', selected: false, weightage: 0 },
      { name: 'Peer', selected: false, weightage: 0 },
      { name: 'Subordinate', selected: false, weightage: 0 },
      { name: 'Internal Customer', selected: false, weightage: 0 },
      { name: 'External Customer', selected: false, weightage: 0 } // optional if needed
    ];

    this.getLocationList = [];
    this.selectedLocationForSetup = [];
    this.getBandList = [];
    this.selectedBandForSetup = [];
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
    this.selectedEmployeeId = [];
    this.listOfEmployees = [];
    this.ratingList = [
      {
        id: null,
        questionType: 'Rating Based',
        rating: null,
        ratingDefinition: ''
      }
    ];
    this.intructionList = [];
    this.stakeholdersArray = [];
    this.getCompetencyList = [];
    this.onSeletReminderOption = false;
    ((this.invitationEmailBody = null), (this.invitationEmailSubject = null), (this.submissionEmailBody = null));
    this.submissionEmailSubject = null;
    this.externalCustomerWeightage = null;
    this.subordinateWeightage = null;
    this.superiorWeightage = null;
    this.selfWeightage = null;
    this.peerWeightage = null;
    this.internalCustomerWeightage = null;
    this.stakeholdersArray = null;
    this.getCompetencyList = [];

    this.getListOfReviewName();
  }
  onStakeholderChange(stakeholder: any) {
    console.log(stakeholder);
    console.log(
      'Selected Stakeholders:',
      this.stakeHoldersArrayForSetup.filter((s: any) => s.selected)
    );
  }

  onChange360DashboardYear(data: any) {
    this.selectedYearCompetencyWise = data;
    this.selectedYearQuestionWise = data;
    this.selectedYearStakeholderWise = data;
    this.selectedYearHowDidFareWise = data;
    this.selectedYearTopandBottom = data;
    this.selectedYearSpiderWeb = data;
    this.listofReviewNamesActiveAndCompletedCompetencyWise = [];
    this.bandlistForCompetencyWiseGraph = [];
    this.empListForCompetencyWiseGraph = [];
    this.competencyWiseGraphData = [];
    this.listofReviewNamesActiveAndCompletedQuestionWise = [];
    this.competencylistForQuestionWiseGraph = [];
    this.listOfEmpForQuestionWise = [];
    this.questionWiseGraphData = [];
    this.listofReviewNamesActiveAndCompletedSatkeholderWise = [];
    this.listOfEmpForStakeholderWise = [];
    this.stakeholderWiseGraphData = [];
    this.listofReviewNamesActiveAndCompletedHowDidIFareWise = [];
    this.howDidIFareWiseGraphData = [];
    this.listofReviewNamesActiveAndCompletedTopandBottomWise = [];
    this.listOfEmpForTopandBottomWise = [];
    this.topandBottomGraphData = [];
    this.listofReviewNamesActiveAndCompletedSpiderGraph = [];
    this.listOfEmpForSpiderGraph = [];
    this.spiderGraphData = [];

    this.switchCompetencyWiseGraphType(this.competencyWiseIcon);
    this.switchQuestionWiseGraphType(this.questionWiseIcon);
    this.switchStakeholderWiseGraphType(this.stakeholderWiseIcon);
    this.switchHowDidIFareGraphType(this.HowDidIFareIcon);
    this.switchtopandBottomWiseGraphType(this.stakeholderWiseIcon);
    this.switchspiderWebGraphType(this.stakeholderWiseIcon);

    this.reviewNamesActiveAndCompleted();
  }

  // onClickDownlaodAtoZTable() {
  //   const test = this.selectedYear?.split('-');
  //   let userID: any;
  //   if (window.innerWidth <= 800) {
  //     userID = [this.selectedEmployeeForReport]
  //   } else {
  //     userID = this.selectedEmployeeForReport.map((ele: any) => ele.id)
  //   }
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "fromYear": test[0],
  //     "reviewId": this.selectedReviewID,
  //     "search": null,
  //     "toYear": test[1],
  //     "userId": userID
  //   }
  //   this.httpService.callPostService(this.config.downloadAtoZReport, request).subscribe((data: any) => {

  //     if (data?.fileUrl != null) {
  //       var fileName = data?.fileUrl?.split(environment.downloadURL)
  //       saveAs(data?.fileUrl, fileName[1]);
  //     }
  //   })
  // }

  onClickDownlaodAtoZTable() {
    const test = this.selectedYear?.split('-');
    let userID: any;

    // check role
    const role = this.loggedInUserRole;

    if (role === 'Super Admin' || role === 'Hr Admin') {
      // download for all selected employees
      if (window.innerWidth <= 800) {
        userID = [this.selectedEmployeeForReport];
      } else {
        userID = this.selectedEmployeeForReport.map((ele: any) => ele.id);
      }
    } else {
      // Employee, HOD, Manager → only their own ID
      userID = [this.loggedInUserId];
    }

    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: test[0],
      toYear: test[1],
      reviewId: this.selectedReviewID,
      search: null,
      userId: userID
    };

    this.httpService.callPostService(this.config.downloadAtoZReport, request).subscribe((data: any) => {
      if (data?.fileUrl) {
        const fileName = data.fileUrl.split(environment.downloadURL);
        saveAs(data.fileUrl, fileName[1]);
      }
    });
  }

  onClickDownlaodScoreGivenByYourReport() {
    const test = this.selectedYear?.split('-');
    let userID = [];
    let isEmployee: any;
    if ((this.selectedSubTab === 'A-Z report' || this.selectedSubTab === 'Score given by you report') && (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin')) {
      let userId: any;
      if (window.innerWidth <= 800) {
        userId = [this.selectedEmployeeForReport];
      } else {
        userId = this.selectedEmployeeForReport.map((ele: any) => ele.id);
      }
      userID = userId;
    } else if ((this.selectedSubTab === 'Trend analysis report' && (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin')) || (this.selectedSubTab === 'Score given by you report' && (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager'))) {
      userID.push(this.selectedEmployeeForReportForTrendAnalysis);
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
      isEmployee = true;
    } else {
      isEmployee = false;
    }
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: null,
      reviewId: this.selectedReviewID,
      toYear: null,
      userId: userID,
      isEmployee: isEmployee
      // "userId": this.selectedEmployeeForReport.map((ele: any) => ele.id)
    };
    console.warn(request);

    this.httpService.callPostService(this.config.downloadScoreGivenByYouReport, request).subscribe((data: any) => {
      if (data?.fileUrl != null) {
        var fileName = data?.fileUrl?.split(environment.downloadURL);
        saveAs(data?.fileUrl, fileName[1]);
      }
    });
  }
  isPastDate(date: Date | string | null): boolean {
    if (!date) return false;
    const selectedDate = new Date(date);
    const today = new Date();
    // Set time to 0 to only compare date part
    selectedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return selectedDate < today;
  }
}
